// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T20:56:33.208Z
// Property: Autumn Oaks Apartments (ID: 6767906449166878)
// Collections: 27 amenities, 10 floorplans (live), 79 photos, 36 POIs, 1 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166878",
  "property_external_id": "495881",
  "property_zillow_url": "https://www.zillow.com/homedetails/1451-Kingswood-Dr-Roseville-CA-95678/188075554_zpid/",
  "property_apartments_url": "https://www.apartments.com/autumn-oaks-roseville-ca/fb4tx8t/",
  "property_google_business_url": "https://share.google/zBaiESiuelVFqyjQd",
  "property_linkedin_url": null,
  "property_hubspot_id": "51934476094",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495881 p0505549",
  "property_status": null,
  "property_slug": "autumn-oaks-apartments",
  "property_name": "Autumn Oaks Apartments",
  "property_website_url": "www.rosevillecaliforniaapartments.com",
  "property_domain": "https://www.rosevillecaliforniaapartments.com/",
  "property_address": "1451 Kingswood Drive",
  "property_full_address": "1451 Kingswood Dr, Roseville, CA 95678",
  "property_address_1": "1451 Kingswood Drive",
  "property_address_2": null,
  "property_address_city": "Roseville",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95678",
  "property_address_country": "US",
  "property_address_county": "Placer County",
  "property_neighborhood_address": "Kaseberg - Kingswood",
  "property_address_latitude": "38.7643",
  "property_address_longitude": "-121.3119",
  "property_email": "autumnoaks@ctlmanagement.com",
  "property_phone": "(279) 237-5137",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Autumn Oaks Apartments in Roseville, CA, your ideal home awaits. Choose from spacious studio to three-bedroom floor plans, complete with amenities like a 24-hour fitness center, two refreshing pools, and a cozy theater room. Embrace a vibrant lifestyle with engaging resident activities and serene scenic views.",
  "property_long_description": "Step into a home designed with style, convenience, and everyday comfort in mind. At Autumn Oaks Apartments, you'll find thoughtfully designed studio, one, two, and three-bedroom floor plans, each equipped with upscale features that support your lifestyle. Start your day with coffee on your private patio, enjoy the warmth of a gas or wood-burning fireplace, or keep everything organized with spacious pantries and storage options. With 16 unique layouts ranging from 540 to 1,164 square feet, there's a space here that's just right for you. Our apartments in Roseville, CA, are available with flexible lease terms, making it easy to settle in for the time that suits you best.Reach out today to schedule your personal tour! We'd love to show you around.Managed by CTL Management, Inc. License # 01090130.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f6c41-3f01-7346-b432-574565b6786c.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool and lounge chairs at an apartment complex on a sunny day.",
    "public_id": "019f6c41-3f01-7346-b432-574565b6786c",
    "storage_key": "property/6767906449166878/019f6c41-3f01-7346-b432-574565b6786c.webp",
    "width": 1800,
    "height": 1202
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "416",
  "property_year_built": "1991",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.75",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $500-600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Maximum Number of Pets: 2 (Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old)\nMaximum Weight Limit: 25 pounds\nMonthly Pet Rent: $30 per pet",
  "property_online_leasing_url": "https://rosevillecaliforniaapartments.securecafe.com/onlineleasing/autumn-oaks-1/floorplans.aspx",
  "property_resident_portal_url": "https://rosevillecaliforniaapartments.securecafe.com/residentservices/autumn-oaks-1/userlogin.aspx",
  "property_apply_now_url": "https://rosevillecaliforniaapartments.securecafe.com/onlineleasing/autumn-oaks-1/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019db13d-c875-75de-9746-9ba68f70271e.webp",
  "property_primary_logo_media": {
    "alt_text": "Autumn Oaks Apartments logo",
    "public_id": "019db13d-c875-75de-9746-9ba68f70271e",
    "storage_key": "property/6767906449166878/019db13d-c875-75de-9746-9ba68f70271e.webp",
    "width": 1318,
    "height": 320
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019db1a1-6b1a-7629-8b87-13c01ca4949c.webp",
  "property_secondary_logo_media": {
    "alt_text": "Autumn Oaks Apartments logo",
    "public_id": "019db1a1-6b1a-7629-8b87-13c01ca4949c",
    "storage_key": "property/6767906449166878/019db1a1-6b1a-7629-8b87-13c01ca4949c.webp",
    "width": 660,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019de45e-699a-77fc-a1e6-c348a8cb5b23.webp",
  "property_fav_icon_media": {
    "alt_text": "Property Logo",
    "public_id": "019de45e-699a-77fc-a1e6-c348a8cb5b23",
    "storage_key": "property/6767906449166878/019de45e-699a-77fc-a1e6-c348a8cb5b23.webp",
    "width": 117,
    "height": 116
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019db14e-6f61-740d-9247-ff35cd04cb5b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Placeholder image",
    "public_id": "019db14e-6f61-740d-9247-ff35cd04cb5b",
    "storage_key": "property/6767906449166878/019db14e-6f61-740d-9247-ff35cd04cb5b.webp",
    "width": 1280,
    "height": 310
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019db14e-63fb-70d0-89ae-12c14499edff.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black rectangle graphic",
    "public_id": "019db14e-63fb-70d0-89ae-12c14499edff",
    "storage_key": "property/6767906449166878/019db14e-63fb-70d0-89ae-12c14499edff.webp",
    "width": 1280,
    "height": 310
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "608 - 1138",
  "property_sqft_min": "608",
  "property_sqft_max": "1138",
  "property_price_range": "1640 - 2850",
  "property_price_min": "1640",
  "property_price_max": "2850",
  "property_available_units": 26,
  "property_facebook_url": "https://www.facebook.com/AutumnOaksApartments/",
  "property_instagram_url": "https://www.instagram.com/campusoaksapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJT1MV-wghm4ARUnbRjb4UdxM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/campus-oaks-apartments-roseville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Autumn Oaks Apartments",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community Today",
  "property_home_amenities_blurb": "Welcome to Autumn Oaks Apartments in beautiful Roseville, CA, where comfort meets convenience. Choose from spacious studio to three-bedroom floor plans, each designed for your lifestyle. Enjoy top-notch amenities like two refreshing pools, a state-of-the-art fitness center, and a welcoming clubhouse—everything you need to feel right at home.",
  "property_home_floorplans_blurb": "At Autumn Oaks Apartments in Roseville, CA, your ideal living space awaits. Choose from stylish studios to spacious three-bedroom layouts, each thoughtfully designed to enhance your lifestyle. Browse our available apartment homes and uncover the perfect floor plan that suits your needs and complements your taste. ",
  "property_home_gallery_blurb": "At Autumn Oaks Apartments in Roseville, CA, life unfolds in style with a variety of floor plans, from cozy studios to spacious three-bedroom layouts. Enjoy exceptional amenities, including two swimming pools, a fitness center, and resident events. Picture yourself living here and savor the perfect blend of comfort and community!",
  "property_home_neighborhood_blurb": "At Autumn Oaks Apartments in Roseville, you'll enjoy a vibrant lifestyle rich in local culture and convenience. From the serene trails of Miner's Ravine to the engaging exhibits at the Maidu Museum, your new home places you amidst stunning parks, top-notch schools, and a variety of entertainment options.",
  "property_home_reviews_blurb": "At Autumn Oaks Apartments in Roseville, CA, residents value our commitment to a peaceful living environment. One long-term resident noted, \"I truly loved it here,\" highlighting the supportive office staff and friendly community. Join a place where kindness thrives, and experience a vibrant lifestyle surrounded by comfort and care.",
  "property_neighborhood_blurb": "Nestled in the heart of Roseville, Autumn Oaks Apartments offers more than just a home—it's a gateway to adventure. With attractions like the Maidu Museum, Roseville Utility Exploration Center, and nearby parks including Royer Park, there's always something to explore. Embrace a vibrant lifestyle filled with activities and cherished moments.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Autumn Oaks Apartments in Roseville, CA, your ideal home awaits. Choose from studios to three-bedroom layouts, complemented by an array of amenities like two sparkling pools, a 24-hour fitness center, and a cozy theater room. Experience comfortable living with modern conveniences, scenic views, and a welcoming community atmosphere.",
  "property_applynow_blurb": "At Autumn Oaks Apartments in Roseville, CA, experience modern living with diverse floor plans from studios to three bedrooms. Indulge in amenities like a 24-hour fitness center, two swimming pools, and a vibrant clubhouse. Embrace comfort and community—lease online today to secure your ideal space. Your new beginning awaits!",
  "property_contactus_blurb": "At Autumn Oaks Apartments in Roseville, CA, we offer a variety of floor plans to fit your lifestyle—from cozy studios to spacious three-bedrooms. Each home is designed for comfort and convenience. Have questions? Contact our leasing team today and start your journey to elegant living!",
  "property_faqs_blurb": "At Autumn Oaks Apartments in Roseville, CA, your ideal living space awaits! Choose from thoughtfully designed studio, one, two, or three-bedroom floor plans to suit your lifestyle. Curious about community details? Dive into our FAQs page for all the answers you need and make your move today!",
  "property_floorplans_blurb": "At Autumn Oaks Apartments in Roseville, CA, we offer a diverse range of floor plans, from cozy studios to spacious three-bedroom layouts. Each design thoughtfully balances comfort and style, ensuring you'll feel right at home. Browse our available apartment homes today and uncover the perfect fit for your lifestyle! ",
  "property_gallery_blurb": "At Autumn Oaks Apartments in Roseville, CA, each spacious floor plan—from cozy studios to expansive three-bedrooms—invites you to unwind. Enjoy exclusive amenities like two refreshing pools, a fully-equipped fitness center, and a vibrant clubhouse that hosts resident activities. Picture yourself living here, surrounded by comfort and style!",
  "property_interactivemap_blurb": "At Autumn Oaks Apartments in Roseville, CA, choose from a variety of spacious floor plans—from studios to three-bedrooms—all featuring luxurious amenities. Enjoy our inviting clubhouse, multiple pools, and a dog park, alongside flexible leasing options. Use our interactive community map to select your perfect home today!",
  "property_pets_blurb": "At Autumn Oaks Apartments in Roseville, CA, your furry friends are embraced within our welcoming community. With a range of pet-friendly options for adult cats and dogs, along with the joy of small caged animals and fish, life here is a vibrant celebration of companionship and comfort.",
  "property_referafriend_blurb": "At Autumn Oaks Apartments in Roseville, CA, your perfect home awaits! Choose from stylish studio, one, two, or three-bedroom floor plans. Great friends make great neighbors—refer a friend to join our vibrant community today and enjoy all the comforts and amenities we have to offer!",
  "property_residentaccess_blurb": "At Autumn Oaks Apartments in Roseville, CA, convenience meets comfort with diverse floor plans including studio, one, two, and three-bedroom options. Enhance your living experience by accessing your resident portal to effortlessly pay rent, schedule maintenance, and manage your community lifestyle—all at your fingertips!",
  "property_reviews_blurb": "Experience the warmth of community at Autumn Oaks Apartments in Roseville, CA! With a heartfelt 4-star rating, our residents appreciate the dedicated staff and quality maintenance. As one resident beautifully noted, “It has been a delightful journey at Autumn Oaks for many years.” Join us today and create your own lasting memories!",
  "property_created_at": "1762784575687",
  "property_scheduletour_blurb": "At Autumn Oaks Apartments in Roseville, CA, we offer a range of elegant floor plans, from cozy studios to spacious three-bedroom homes. Schedule a tour today and experience the vibrant community that awaits you. Curious about life here? Check out our residents' testimonials for an insider's view!",
  "property_thankyou_blurb": "Thank you for reaching out to Autumn Oaks Apartments in beautiful Roseville, CA! From cozy studios to spacious three-bedroom layouts, we offer a variety of floor plans tailored to your lifestyle. Stay tuned—our team will connect with you soon to help you find your perfect home!",
  "property_virtualtours_blurb": "Step into the charm of Autumn Oaks Apartments in Roseville, CA, where comfort meets style. Our diverse floor plans—ranging from cozy studios to spacious three-bedroom units—cater to every lifestyle. Experience a unique virtual tour today and imagine your next home filled with warmth and inviting tranquility.",
  "property_copyright": "2026 All Rights Reserved. Autumn Oaks Apartments",
  "property_seo_title_home": "Autumn Oaks Apartments |  Apartments in Roseville, CA",
  "property_seo_description_home": "Experience luxury living at Autumn Oaks Apartments, Roseville, CA. Choose from diverse floor plans and enjoy pools, a clubhouse, and more!",
  "property_seo_title_floorplans": "Floor Plans | Roseville, CA Apartments for Rent",
  "property_seo_description_floorplans": "Discover your sanctuary at Autumn Oaks Apartments in Roseville, CA, with spacious studios to cozy three-bedroom layouts. Your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Roseville, CA Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Autumn Oaks Apartments in Roseville, CA, featuring pools, a clubhouse, and flexible leases. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Roseville, CA",
  "property_seo_description_gallery": "Immerse yourself in Autumn Oaks Apartments, Roseville's serene retreat! From stunning floor plans to vibrant amenities, visualize your perfect life today.",
  "property_seo_title_virtualtours": "Virtual Tours | Autumn Oaks Apartments Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Autumn Oaks Apartments in Roseville, CA. Take a virtual tour today to envision your new home with various floor plans!",
  "property_seo_title_interactivemap": "Interactive Map | Autumn Oaks Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Autumn Oaks Apartments in Roseville, CA. Use our interactive map to explore floor plans, amenities, and discover your new lifestyle!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Roseville, CA",
  "property_seo_description_neighborhood": "Uncover Roseville’s charm at Autumn Oaks Apartments! From studios to three-bedroom homes, explore local favorites and vibrant hotspots just steps away.",
  "property_seo_title_contact": "Contact Us | Autumn Oaks Apartments",
  "property_seo_description_contact": "Discover Autumn Oaks Apartments in Roseville, CA! From studios to three-bedrooms, our leasing team is here to help. Contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Roseville, CA",
  "property_seo_description_faqs": "Uncover all you need to know about Autumn Oaks Apartments in Roseville, CA! Visit our FAQs for insights on our floor plans, amenities, and community life.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Roseville, CA",
  "property_seo_description_reviews": "Join our vibrant community at Autumn Oaks Apartments in Roseville, CA. See resident reviews and find your perfect home with stunning amenities today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Roseville, CA",
  "property_seo_description_applynow": "Discover your ideal home at Autumn Oaks Apartments, Roseville, CA. Great amenities, flexible leases, and stunning views—apply online now!",
  "property_seo_title_residentaccess": "Resident Access | Autumn Oaks Apartments",
  "property_seo_description_residentaccess": "Experience convenience at Autumn Oaks Apartments in Roseville, CA. Log in to the resident portal to pay rent, request maintenance, and stay connected!",
  "property_seo_title_referafriend": "Refer A Friend | Autumn Oaks Apartments",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Autumn Oaks Apartments in Roseville, CA, and enjoy a thriving community together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Autumn Oaks Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Autumn Oaks Apartments in Roseville, CA! Schedule your tour today and envision the lifestyle you've always wanted.",
  "property_seo_title_privacy": "Privacy Policy | Autumn Oaks Apartments",
  "property_seo_description_privacy": "At Autumn Oaks Apartments, your privacy matters. Discover how we safeguard your data for a secure living experience in Roseville, CA.",
  "property_seo_title_accessibility": "Website Accessibility | Autumn Oaks Apartments",
  "property_seo_description_accessibility": "At Autumn Oaks Apartments in Roseville, CA, we prioritize digital inclusion. Discover how our accessibility features ensure a welcoming home for everyone.",
  "property_seo_title_sitemap": "Sitemap | Autumn Oaks Apartments",
  "property_seo_description_sitemap": "Uncover the seamless layout of Autumn Oaks Apartments in Roseville, CA. Navigate your way to your future home—check out our sitemap today!",
  "property_seo_title_thankyou": "Thank You | Autumn Oaks Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to vibrant living at Autumn Oaks in Roseville, CA, begins now. Expect a swift response from our friendly team!",
  "property_seo_title_pets": "Pet Policy | Apartments in Roseville, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1784311923117",
  "amenities": [
    {
      "id": "ec_6e4027a1f46a6c2e6602a407",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428506",
      "title": "Clubhouse with Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-795f-71ec-8d5d-f0afb9c39891.webp",
      "amenity_image_media": {
        "alt_text": "Modern common area with a kitchen bar and seating area.",
        "public_id": "019f4aa4-795f-71ec-8d5d-f0afb9c39891",
        "storage_key": "property/6767906449166878/019f4aa4-795f-71ec-8d5d-f0afb9c39891.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A living room with grey couches and a bar area at Autumn Oaks Apartments, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2c554d2e04517db6a5dc6fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428504",
      "title": "Business Center With Wi-Fi Hot Spot",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08aa-5884-77db-b6f2-04fdd63363c0.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers and a lounge area with a sofa and chairs.",
        "public_id": "019d08aa-5884-77db-b6f2-04fdd63363c0",
        "storage_key": "property/6767906449166878/019d08aa-5884-77db-b6f2-04fdd63363c0.webp",
        "width": 3072,
        "height": 2304
      },
      "amenity_image_alt_text": "Autumn Oaks business center",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f4c7063cc30393a7bb0ac6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428501",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-7af8-7484-a9df-28ecef5ef129.webp",
      "amenity_image_media": {
        "alt_text": "Gym equipment in a community fitness center with mirrors and treadmills.",
        "public_id": "019f4aa4-7af8-7484-a9df-28ecef5ef129",
        "storage_key": "property/6767906449166878/019f4aa4-7af8-7484-a9df-28ecef5ef129.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A gym with a variety of equipment including a treadmill, weights, and a bench press at Autumn Oaks Apartments, Roseville, CA, 95678,A gym with a variety of equipment including a treadmill, a stationary bike, and a weight bench at Autumn Oaks Apartments, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4126241bc78dadf244cf4928",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428507",
      "title": "Theater Room With Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0902a93703486d6c8b9724cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428509",
      "title": "Laundry Facilities Available On-Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-7d9e-74a2-8454-a001b5661743.webp",
      "amenity_image_media": {
        "alt_text": "Interior view of the laundry room with multiple washing and drying machines.",
        "public_id": "019f4aa4-7d9e-74a2-8454-a001b5661743",
        "storage_key": "property/6767906449166878/019f4aa4-7d9e-74a2-8454-a001b5661743.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A laundry room with a white counter and a plant in the corner at Autumn Oaks Apartments, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4301fa0057ede22ef57e5372",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428503",
      "title": "2 Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-7b3a-7549-be56-c436b62448bb.webp",
      "amenity_image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and palm trees under a clear blue sky.",
        "public_id": "019f4aa4-7b3a-7549-be56-c436b62448bb",
        "storage_key": "property/6767906449166878/019f4aa4-7b3a-7549-be56-c436b62448bb.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A large swimming pool with lounge chairs and a fountain in the middle at Autumn Oaks Apartments, Roseville, CA,A pool surrounded by lawn chairs in front of a building at Autumn Oaks Apartments, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b814ee1427da8b5a06a75434",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428511",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-7bab-76ac-91c2-73c459da6d6b.webp",
      "amenity_image_media": {
        "alt_text": "Apartment complex swimming pool and hot tub area with lounge chairs and umbrellas.",
        "public_id": "019f4aa4-7bab-76ac-91c2-73c459da6d6b",
        "storage_key": "property/6767906449166878/019f4aa4-7bab-76ac-91c2-73c459da6d6b.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A swimming pool with a hot tub at Autumn Oaks Apartments, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f91b64bf02b7809ef540b42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428505",
      "title": "Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b9-3e09-734c-8984-f2b27ff920a2.webp",
      "amenity_image_media": {
        "alt_text": "Garage doors with blue roll-up doors in a parking lot with palm trees and trees.",
        "public_id": "019d20b9-3e09-734c-8984-f2b27ff920a2",
        "storage_key": "property/6767906449166878/019d20b9-3e09-734c-8984-f2b27ff920a2.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Garages at Autumn Oaks Apartments, Roseville, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd08ca77eca4cb6a6f81d82f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "86393134",
      "title": "Clubhouse Rentals",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-8c37-7480-8944-e7f4175e1485.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019f4aa4-8c37-7480-8944-e7f4175e1485",
        "storage_key": "property/6767906449166878/019f4aa4-8c37-7480-8944-e7f4175e1485.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A kitchen with wooden cabinets and a stainless steel dishwasher at Autumn Oaks Apartments, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e981b67e7f06899c4532b683",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80665136",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-9412-70c3-97be-2303d13da57a.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slides and climbing wall",
        "public_id": "019f4aa4-9412-70c3-97be-2303d13da57a",
        "storage_key": "property/6767906449166878/019f4aa4-9412-70c3-97be-2303d13da57a.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A green slide in a playground surrounded by trees at Autumn Oaks Apartments, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb865df344aa3f07155da981",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80665135",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-9831-778d-b9e0-3d56e89db164.webp",
      "amenity_image_media": {
        "alt_text": "Playground tunnel for pets in a fenced dog park area.",
        "public_id": "019f4aa4-9831-778d-b9e0-3d56e89db164",
        "storage_key": "property/6767906449166878/019f4aa4-9831-778d-b9e0-3d56e89db164.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A dog park with a beige cylinder and bark dust at Autumn Oaks Apartments, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7dac5e137ead2c08932165d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "87310391",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-92e4-709d-8e6f-92e97aa99c72.webp",
      "amenity_image_media": {
        "alt_text": "Parcel pending lockers",
        "public_id": "019f4aa4-92e4-709d-8e6f-92e97aa99c72",
        "storage_key": "property/6767906449166878/019f4aa4-92e4-709d-8e6f-92e97aa99c72.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A row of brown lockers are lined up in a room at Autumn Oaks Apartments, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4fac8e0ef7ec0e32bf94105",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "86393138",
      "title": "Onsite Guest Suite Rentals",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5bbe2cf295fb2cef0936d17f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428518",
      "title": "Reserved Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5c3554a0b21342708fa5c8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "82390122",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71a6568f460f82ec82b736ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "82390124",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcc2af1b230c8b3b7ed87a5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428510",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_facd0081e3ae8e3584b3ef59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "86393139",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84c99856974562806b401d7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "86393140",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_27fffef0ab922a69106e8001",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428515",
      "title": "Gas Or Woodburning Fireplaces",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-058a-71e9-8cc0-d75fe359805b.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace, blue armchair, and two white ottomans.",
        "public_id": "019d08a9-058a-71e9-8cc0-d75fe359805b",
        "storage_key": "property/6767906449166878/019d08a9-058a-71e9-8cc0-d75fe359805b.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Model Silverleaf II entry at Autumn Oaks Apartments, Roseville, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_90d91c73297f19f1a40ba7b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428513",
      "title": "Centralized Heating And Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99f50a14bd3c6304ded7ccc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428517",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-96b7-72de-bf55-d1ebfb42a21c.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with a table and chairs and a view of the apartment complex.",
        "public_id": "019f4aa4-96b7-72de-bf55-d1ebfb42a21c",
        "storage_key": "property/6767906449166878/019f4aa4-96b7-72de-bf55-d1ebfb42a21c.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A patio with a table and two chairs at Autumn Oaks Apartments, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_869a169e518d026a5c16c93c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428514",
      "title": "In-Unit Washer & Dryer (Not Included In Studio Apartments)*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-5ce4-726a-9495-ee16f34ec490.webp",
      "amenity_image_media": {
        "alt_text": "Whirlpool washing machine and dryer in a laundry closet with a wire shelf.",
        "public_id": "019d08a9-5ce4-726a-9495-ee16f34ec490",
        "storage_key": "property/6767906449166878/019d08a9-5ce4-726a-9495-ee16f34ec490.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Two white washing machines in a small laundry room at Autumn Oaks Apartments, Roseville, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4e5fffdeb7e6047bf2b7c29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428519",
      "title": "Vaulted Ceilings - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-6a8d-76f8-8fb9-a581d9c1cb14.webp",
      "amenity_image_media": {
        "alt_text": "Interior view of an empty apartment living room with high ceilings and large windows.",
        "public_id": "019d08a9-6a8d-76f8-8fb9-a581d9c1cb14",
        "storage_key": "property/6767906449166878/019d08a9-6a8d-76f8-8fb9-a581d9c1cb14.webp",
        "width": 1200,
        "height": 798
      },
      "amenity_image_alt_text": "Vacant Entry & Living Room Windows at Autumn Oaks Apartments, California, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_325fff8c8d968d834030bd49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428520",
      "title": "Walk-In Closets - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-81ea-705f-ae4b-4a85bc40df5d.webp",
      "amenity_image_media": {
        "alt_text": "Walk-in closet with shelving",
        "public_id": "019d08a9-81ea-705f-ae4b-4a85bc40df5d",
        "storage_key": "property/6767906449166878/019d08a9-81ea-705f-ae4b-4a85bc40df5d.webp",
        "width": 3072,
        "height": 2044
      },
      "amenity_image_alt_text": "Vacant Bedroom Walk In Closet at Autumn Oaks Apartments, Roseville, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e7c541dfbef188c3d2ac57c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "80428516",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c98557f35996a63966e7daf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "external_id": "87310392",
      "title": "Scenic Views - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_0d3870b0cc05da311f4244fb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-6bc2-722c-892b-192347faf6a2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, granite countertops, and a breakfast bar with stools.",
        "public_id": "019f4aa4-6bc2-722c-892b-192347faf6a2",
        "storage_key": "property/6767906449166878/019f4aa4-6bc2-722c-892b-192347faf6a2.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish kitchen featuring sleek white cabinetry, a breakfast bar, and ample counter space.",
      "link": "false",
      "alt_text": "Modern kitchen with black appliances, granite countertops, and a breakfast bar with stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_WillowIModelKitchen.jpg"
    },
    {
      "id": "ec_fce6e7f9fcb73d2cb2971ce4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-aff4-756f-9602-69950c074dc1.webp",
      "image_media": {
        "alt_text": "Kitchen with black refrigerator, white cabinets, and granite countertops.",
        "public_id": "019f4aa4-aff4-756f-9602-69950c074dc1",
        "storage_key": "property/6767906449166878/019f4aa4-aff4-756f-9602-69950c074dc1.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this fully equipped kitchen featuring a black refrigerator, ample white cabinetry, and elegant granite countertops with a breakfast bar.",
      "link": "false",
      "alt_text": "Kitchen with black refrigerator, white cabinets, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_WillowIModelKitchenBar.jpg"
    },
    {
      "id": "ec_8d68ac961cdab6722abe9afc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-b37d-702a-bde8-7630ef1e409d.webp",
      "image_media": {
        "alt_text": "Kitchen with black stove, oven, and stainless steel sink with white cabinets.",
        "public_id": "019f4aa4-b37d-702a-bde8-7630ef1e409d",
        "storage_key": "property/6767906449166878/019f4aa4-b37d-702a-bde8-7630ef1e409d.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a black stove and oven, stainless steel double sink, and ample white cabinetry for storage.",
      "link": "false",
      "alt_text": "Kitchen with black stove, oven, and stainless steel sink with white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_WillowIModelKitchenSideView.jpg"
    },
    {
      "id": "ec_79e70418a614df6a7fe80852",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-ae3b-77ab-9453-6180ad5c7955.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops, open to living room with fireplace.",
        "public_id": "019f4aa4-ae3b-77ab-9453-6180ad5c7955",
        "storage_key": "property/6767906449166878/019f4aa4-ae3b-77ab-9453-6180ad5c7955.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Step into this inviting apartment featuring a well-equipped kitchen with ample counter space and modern appliances, flowing seamlessly into a comfortable living area with a cozy fireplace.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops, open to living room with fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_WillowIModelKitchenLivingRoomView.jpg"
    },
    {
      "id": "ec_3571e738c9521bedc7d7a5c9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-af3e-7257-9712-0ec1cc0c7aef.webp",
      "image_media": {
        "alt_text": "Bright and airy living room with a grey sofa, armchair, coffee table, and fireplace.",
        "public_id": "019f4aa4-af3e-7257-9712-0ec1cc0c7aef",
        "storage_key": "property/6767906449166878/019f4aa4-af3e-7257-9712-0ec1cc0c7aef.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Enjoy this spacious living area, perfect for relaxing or entertaining. Features include a comfortable sofa, stylish armchair, and a cozy fireplace.",
      "link": "false",
      "alt_text": "Bright and airy living room with a grey sofa, armchair, coffee table, and fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_WillowIModelLivingRoomPatioDoor.jpg"
    },
    {
      "id": "ec_bc2451c6f17eda7f55add669",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-adbf-71ae-8a0b-fb76805ae5a6.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, armchair, coffee table, fireplace, and large window.",
        "public_id": "019f4aa4-adbf-71ae-8a0b-fb76805ae5a6",
        "storage_key": "property/6767906449166878/019f4aa4-adbf-71ae-8a0b-fb76805ae5a6.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable sofa, decorative armchair, a modern coffee table, and a fireplace, perfect for relaxing evenings.",
      "link": "false",
      "alt_text": "Living room with a gray sofa, armchair, coffee table, fireplace, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_WillowIModelLivingRoom.jpg"
    },
    {
      "id": "ec_113cf68d3e4c619f3c4f1f33",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-c6dd-7272-af6b-aea869c09e03.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, blue sofa, accent chairs, and a galley kitchen.",
        "public_id": "019f4aa4-c6dd-7272-af6b-aea869c09e03",
        "storage_key": "property/6767906449166878/019f4aa4-c6dd-7272-af6b-aea869c09e03.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Cozy living area featuring a fireplace and comfortable seating, opening to a modern galley kitchen with bar seating. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with fireplace, blue sofa, accent chairs, and a galley kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_WillowIModelLivingRoomFireplace.jpg"
    },
    {
      "id": "ec_c5b60b873e873a23e482cf62",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-96b7-72de-bf55-d1ebfb42a21c.webp",
      "image_media": {
        "alt_text": "Balcony with a table and chairs and a view of the apartment complex.",
        "public_id": "019f4aa4-96b7-72de-bf55-d1ebfb42a21c",
        "storage_key": "property/6767906449166878/019f4aa4-96b7-72de-bf55-d1ebfb42a21c.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this private balcony, complete with a table and chairs.",
      "link": "false",
      "alt_text": "Balcony with a table and chairs and a view of the apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_WillowIModelPatio.jpg"
    },
    {
      "id": "ec_dea0826eb361c812241c754a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-c7de-7396-aed3-df030d96dc26.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstands, and a sliding glass door leading to an outdoor patio.",
        "public_id": "019f4aa4-c7de-7396-aed3-df030d96dc26",
        "storage_key": "property/6767906449166878/019f4aa4-c7de-7396-aed3-df030d96dc26.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom featuring a queen-size bed, stylish nightstands, and ample natural light from the sliding glass door. Step out onto your private patio for a breath of fresh air.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstands, and a sliding glass door leading to an outdoor patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_WillowIModelPrimaryBedroomPatio.jpg"
    },
    {
      "id": "ec_1127f1e7b2ff1fa59a5675af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-c5c5-757c-9e73-d5fa9e25ffef.webp",
      "image_media": {
        "alt_text": "Queen size bed with plush bedding and two nightstands with lamps.",
        "public_id": "019f4aa4-c5c5-757c-9e73-d5fa9e25ffef",
        "storage_key": "property/6767906449166878/019f4aa4-c5c5-757c-9e73-d5fa9e25ffef.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a queen-size bed with comfortable bedding, elegant nightstands, and ample closet space.",
      "link": "false",
      "alt_text": "Queen size bed with plush bedding and two nightstands with lamps.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_WillowIModelPrimaryBedroom.jpg"
    },
    {
      "id": "ec_cdcc2f9892ddfaa8249f857c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-c83f-7324-b946-ed0d48d5f242.webp",
      "image_media": {
        "alt_text": "Clean bathroom with a vanity, sink, tri-fold mirror, and a bathtub with shower curtain and toilet.",
        "public_id": "019f4aa4-c83f-7324-b946-ed0d48d5f242",
        "storage_key": "property/6767906449166878/019f4aa4-c83f-7324-b946-ed0d48d5f242.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a vanity with a sink, a tri-fold mirror, a bathtub with a shower curtain, and a toilet.",
      "link": "false",
      "alt_text": "Clean bathroom with a vanity, sink, tri-fold mirror, and a bathtub with shower curtain and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_WillowIModelBathroom.jpg"
    },
    {
      "id": "ec_e6c2c826a2e1b0e0197e2dcd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ae-3bdc-74d8-95c9-55605dccc439.webp",
      "image_media": {
        "alt_text": "Kitchen area with white cabinets, black appliances, and a stainless steel sink.",
        "public_id": "019d08ae-3bdc-74d8-95c9-55605dccc439",
        "storage_key": "property/6767906449166878/019d08ae-3bdc-74d8-95c9-55605dccc439.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring white cabinetry, a black electric range, a dishwasher, and a spacious stainless steel sink. Perfect for home chefs.",
      "link": "false",
      "alt_text": "Kitchen area with white cabinets, black appliances, and a stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ModelSilverleafIIKitchen.jpg"
    },
    {
      "id": "ec_dd6187a990f4f9bebc7789e2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b8-515e-7679-bdbd-6591769d5507.webp",
      "image_media": {
        "alt_text": "Dining area with a marble table and blue chairs, overlooking a kitchen pass-through.",
        "public_id": "019d20b8-515e-7679-bdbd-6591769d5507",
        "storage_key": "property/6767906449166878/019d20b8-515e-7679-bdbd-6591769d5507.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy a meal in this charming dining area, perfect for intimate gatherings, adjacent to a convenient pass-through kitchen.",
      "link": "false",
      "alt_text": "Dining area with a marble table and blue chairs, overlooking a kitchen pass-through.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ModelSilverleafIIDiningRoom.jpg"
    },
    {
      "id": "ec_98afb4272cbdec2bdd82b09b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b8-79f5-7248-bc42-dc44d62b1958.webp",
      "image_media": {
        "alt_text": "Living room with a beige sofa, blue accent chair, white ottomans, and fireplace.",
        "public_id": "019d20b8-79f5-7248-bc42-dc44d62b1958",
        "storage_key": "property/6767906449166878/019d20b8-79f5-7248-bc42-dc44d62b1958.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, chic accent chairs, and a cozy fireplace. Perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Living room with a beige sofa, blue accent chair, white ottomans, and fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ModelSilverleafIILivingRoom.jpg"
    },
    {
      "id": "ec_05d6fc12ce08297c2b56c4dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-058a-71e9-8cc0-d75fe359805b.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, blue armchair, and two white ottomans.",
        "public_id": "019d08a9-058a-71e9-8cc0-d75fe359805b",
        "storage_key": "property/6767906449166878/019d08a9-058a-71e9-8cc0-d75fe359805b.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, stylish seating, and access to an outdoor patio.",
      "link": "false",
      "alt_text": "Living room with fireplace, blue armchair, and two white ottomans.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ModelSilverleafIIEntry.jpg"
    },
    {
      "id": "ec_9f4ed5ecbd62fed79a320b9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b8-553e-7711-9808-7b2df44ea1bf.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, dining table, and fireplace.",
        "public_id": "019d20b8-553e-7711-9808-7b2df44ea1bf",
        "storage_key": "property/6767906449166878/019d20b8-553e-7711-9808-7b2df44ea1bf.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, elegant armchair, and a dining area, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with sofa, armchair, dining table, and fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ModelSilverleafIILivingRoomDiningRoom.jpg"
    },
    {
      "id": "ec_7fe260a3710b1d04c8d80681",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b8-51da-7419-add5-141b8cf619f9.webp",
      "image_media": {
        "alt_text": "Hallway with laundry closet containing washer and dryer",
        "public_id": "019d20b8-51da-7419-add5-141b8cf619f9",
        "storage_key": "property/6767906449166878/019d20b8-51da-7419-add5-141b8cf619f9.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry closet with washer and dryer, plus shelving for storage.",
      "link": "false",
      "alt_text": "Hallway with laundry closet containing washer and dryer",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ModelSilverleafIIHallway.jpg"
    },
    {
      "id": "ec_2c7122e8803e17baf102f18d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-c9d6-766b-9a3c-94a82fe7bed3.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, blue headboard, and large window.",
        "public_id": "019f4aa4-c9d6-766b-9a3c-94a82fe7bed3",
        "storage_key": "property/6767906449166878/019f4aa4-c9d6-766b-9a3c-94a82fe7bed3.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a queen bed, elegant blue headboard, and a spacious closet. Perfect for relaxation and comfort.",
      "link": "false",
      "alt_text": "Bedroom with a queen-sized bed, blue headboard, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_SilverleafIIModelPrimaryBedroom.jpg"
    },
    {
      "id": "ec_ade3d361ddf1eb257db1b33d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-daac-767a-ac07-64ff30ad8f2b.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, a decorative headboard, and a large potted plant.",
        "public_id": "019f4aa4-daac-767a-ac07-64ff30ad8f2b",
        "storage_key": "property/6767906449166878/019f4aa4-daac-767a-ac07-64ff30ad8f2b.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed and elegant decor. The adjacent en-suite bathroom offers additional convenience.",
      "link": "false",
      "alt_text": "A bedroom with a queen-size bed, a decorative headboard, and a large potted plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_SilverleafIIModelPrimaryBedroomBathroom.jpg"
    },
    {
      "id": "ec_2765a57ab406e8457b618b47",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b8-8de0-748a-98fc-4883d4bd538e.webp",
      "image_media": {
        "alt_text": "A modern bathroom featuring a granite countertop, stainless steel faucet, and a decorative mannequin.",
        "public_id": "019d20b8-8de0-748a-98fc-4883d4bd538e",
        "storage_key": "property/6767906449166878/019d20b8-8de0-748a-98fc-4883d4bd538e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed bathroom with a spacious granite vanity, modern fixtures, and stylish decor, creating a spa-like atmosphere.",
      "link": "false",
      "alt_text": "A modern bathroom featuring a granite countertop, stainless steel faucet, and a decorative mannequin.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ModelSilverleafIIPrimaryBathroom.jpg"
    },
    {
      "id": "ec_342bfb4a757afcf2f9d7dc50",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-dd5e-720e-9ae6-43c28ec71870.webp",
      "image_media": {
        "alt_text": "A daybed with navy and patterned pillows sits next to a desk with a lamp and a book.",
        "public_id": "019f4aa4-dd5e-720e-9ae6-43c28ec71870",
        "storage_key": "property/6767906449166878/019f4aa4-dd5e-720e-9ae6-43c28ec71870.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a versatile daybed perfect for lounging or sleeping, alongside a dedicated workspace with a stylish lamp and decorative accents.",
      "link": "false",
      "alt_text": "A daybed with navy and patterned pillows sits next to a desk with a lamp and a book.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_SilverleafIIModelSecondBedroom.jpg"
    },
    {
      "id": "ec_6f511bd9699b849fb3d41b73",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-5ce4-726a-9495-ee16f34ec490.webp",
      "image_media": {
        "alt_text": "Whirlpool washing machine and dryer in a laundry closet with a wire shelf.",
        "public_id": "019d08a9-5ce4-726a-9495-ee16f34ec490",
        "storage_key": "property/6767906449166878/019d08a9-5ce4-726a-9495-ee16f34ec490.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry area with a Whirlpool washing machine and dryer, complete with a wire shelf for storage.",
      "link": "false",
      "alt_text": "Whirlpool washing machine and dryer in a laundry closet with a wire shelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_VacantCanyonIILaundry.jpg"
    },
    {
      "id": "ec_1a32057959766a0aa239398b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b8-8aed-715b-9348-ec6524dfb174.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower.",
        "public_id": "019d20b8-8aed-715b-9348-ec6524dfb174",
        "storage_key": "property/6767906449166878/019d20b8-8aed-715b-9348-ec6524dfb174.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, complete with a modern vanity, toilet, and a stylish shower with a decorative curtain.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ModelSilverleafIISecondBathroom.jpg"
    },
    {
      "id": "ec_2e6823d576fd19b89357ce43",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-dc56-736e-9ba2-ffccca78f098.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black countertops, stainless steel sink, dishwasher, and stove.",
        "public_id": "019f4aa4-dc56-736e-9ba2-ffccca78f098",
        "storage_key": "property/6767906449166878/019f4aa4-dc56-736e-9ba2-ffccca78f098.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Explore this modern kitchen featuring ample cabinet space, sleek black countertops, and essential appliances for comfortable living.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black countertops, stainless steel sink, dishwasher, and stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ScarletIIVacantKitchenPantry.jpg"
    },
    {
      "id": "ec_06c7697dacddaf37b37b9a60",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-de95-70a8-892a-14fd97c0eb3c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances and white cabinetry.",
        "public_id": "019f4aa4-de95-70a8-892a-14fd97c0eb3c",
        "storage_key": "property/6767906449166878/019f4aa4-de95-70a8-892a-14fd97c0eb3c.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Bright and airy kitchen featuring a dishwasher, refrigerator, oven, and ample cabinet space.",
      "link": "false",
      "alt_text": "Modern kitchen with black appliances and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ScarletIIVacantKitchen.jpg"
    },
    {
      "id": "ec_f0e95506cbf2c2353cd736ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-6dce-715b-92d8-0c12e54fe6f6.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and vaulted ceiling",
        "public_id": "019d08a9-6dce-715b-92d8-0c12e54fe6f6",
        "storage_key": "property/6767906449166878/019d08a9-6dce-715b-92d8-0c12e54fe6f6.webp",
        "width": 3072,
        "height": 2039
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, vaulted ceilings, and large windows that let in natural light.",
      "link": "false",
      "alt_text": "Living room with fireplace and vaulted ceiling",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_VacantFireplaceLivingRoom.jpg"
    },
    {
      "id": "ec_08302f91f14cca6b42d9ce77",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-6a8d-76f8-8fb9-a581d9c1cb14.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment living room with high ceilings and large windows.",
        "public_id": "019d08a9-6a8d-76f8-8fb9-a581d9c1cb14",
        "storage_key": "property/6767906449166878/019d08a9-6a8d-76f8-8fb9-a581d9c1cb14.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Spacious living area with vaulted ceilings and abundant natural light. This room offers a great space for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Interior view of an empty apartment living room with high ceilings and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Autumn Oaks_Roseville_CA_Vacant Entry.jpg"
    },
    {
      "id": "ec_321bea4dae8ed18f18d6cac6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-7d7a-7219-a37a-9b18ea0ef52c.webp",
      "image_media": {
        "alt_text": "Built-in white cabinets and closet doors in an apartment hallway.",
        "public_id": "019d08a9-7d7a-7219-a37a-9b18ea0ef52c",
        "storage_key": "property/6767906449166878/019d08a9-7d7a-7219-a37a-9b18ea0ef52c.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Spacious apartment hallway featuring ample built-in white cabinets and louvered closet doors, leading to a living area.",
      "link": "false",
      "alt_text": "Built-in white cabinets and closet doors in an apartment hallway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Autumn Oaks_Roseville_CA_Vacant Hallway.jpg"
    },
    {
      "id": "ec_bf6935e7968bc9b3289087c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-80c1-717b-be73-13a0bf55540a.webp",
      "image_media": {
        "alt_text": "View of a bathroom with a toilet and vanity",
        "public_id": "019d08a9-80c1-717b-be73-13a0bf55540a",
        "storage_key": "property/6767906449166878/019d08a9-80c1-717b-be73-13a0bf55540a.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Step into a well-lit bathroom featuring a spacious vanity and a convenient toilet, perfect for your daily routine.",
      "link": "false",
      "alt_text": "View of a bathroom with a toilet and vanity",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Autumn Oaks_Roseville_CA_Vacant Bedroom.jpg"
    },
    {
      "id": "ec_64e031b2ab58c0633bb7e2c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-e2d0-748b-9c3e-d04b096d8dfe.webp",
      "image_media": {
        "alt_text": "Bedroom with carpet and vanity area with double sinks and mirrored wall.",
        "public_id": "019f4aa4-e2d0-748b-9c3e-d04b096d8dfe",
        "storage_key": "property/6767906449166878/019f4aa4-e2d0-748b-9c3e-d04b096d8dfe.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting and a dedicated vanity area with double sinks and a large mirror, perfect for getting ready.",
      "link": "false",
      "alt_text": "Bedroom with carpet and vanity area with double sinks and mirrored wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ScarletIIVacantPrimaryBedroomSinks.jpg"
    },
    {
      "id": "ec_eade0b7c06c6c09ee0f42a30",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-82ec-73a4-be4a-9494320e67ac.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with two sinks, large mirror, and a doorway to another room.",
        "public_id": "019d08a9-82ec-73a4-be4a-9494320e67ac",
        "storage_key": "property/6767906449166878/019d08a9-82ec-73a4-be4a-9494320e67ac.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Spacious double vanity bathroom featuring two sinks and a large mirror. Ample storage is provided by the cabinetry below the countertop.",
      "link": "false",
      "alt_text": "Double vanity bathroom with two sinks, large mirror, and a doorway to another room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Autumn Oaks_Roseville_CA_Vacant Bathroom.jpg"
    },
    {
      "id": "ec_a7bea9e0bef2047eeaa27aad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b8-9e97-7279-9316-775afa94a59c.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black countertops, a black refrigerator, and a pantry.",
        "public_id": "019d20b8-9e97-7279-9316-775afa94a59c",
        "storage_key": "property/6767906449166878/019d20b8-9e97-7279-9316-775afa94a59c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring ample cabinet space, a pantry, and modern appliances. Perfect for all your culinary needs.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black countertops, a black refrigerator, and a pantry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_VacantCanyonIIKitchen.jpg"
    },
    {
      "id": "ec_fce2e1169ef4f86c13bde68c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-abae-718c-bcc0-8b59a42823f2.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and sliding glass door",
        "public_id": "019d08a9-abae-718c-bcc0-8b59a42823f2",
        "storage_key": "property/6767906449166878/019d08a9-abae-718c-bcc0-8b59a42823f2.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a modern fireplace and access to a patio or balcony through sliding glass doors. The room has light-colored walls and wood-look flooring.",
      "link": "false",
      "alt_text": "Living room with fireplace and sliding glass door",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_VacantCanyonIILivingRoomFireplace.jpg"
    },
    {
      "id": "ec_f6eef68da4f7c6d0d0abee9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-abe9-778f-8c3c-b5bea4692268.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and adjacent kitchen, featuring wood-look flooring and white cabinets.",
        "public_id": "019d08a9-abe9-778f-8c3c-b5bea4692268",
        "storage_key": "property/6767906449166878/019d08a9-abe9-778f-8c3c-b5bea4692268.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living area with a cozy fireplace, seamlessly connecting to a functional kitchen with modern appliances and ample cabinet space. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "Living room with fireplace and adjacent kitchen, featuring wood-look flooring and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_VacantCanyonIIEntry.jpg"
    },
    {
      "id": "ec_0d4603b4e27177fd814008bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-a915-75c1-8b18-1f6a48ff4d16.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and en-suite bathroom.",
        "public_id": "019d08a9-a915-75c1-8b18-1f6a48ff4d16",
        "storage_key": "property/6767906449166878/019d08a9-a915-75c1-8b18-1f6a48ff4d16.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a walk-in closet and a private en-suite bathroom.",
      "link": "false",
      "alt_text": "Bedroom with closet and en-suite bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_VacantCanyonIIPrimaryBedroom.jpg"
    },
    {
      "id": "ec_cbc4c6f52875c600731bfdd6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-d635-7509-9b88-29bbbadf0fef.webp",
      "image_media": {
        "alt_text": "White bathtub and shower area, with a toilet and vanity visible in the background.",
        "public_id": "019d08a9-d635-7509-9b88-29bbbadf0fef",
        "storage_key": "property/6767906449166878/019d08a9-d635-7509-9b88-29bbbadf0fef.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub/shower combo, toilet, and a vanity with a granite countertop. Wood-look vinyl flooring adds a modern touch.",
      "link": "false",
      "alt_text": "White bathtub and shower area, with a toilet and vanity visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_VacantCanyonIIPrimaryBathroom.jpg"
    },
    {
      "id": "ec_a36aba646b9cbfd66bf76e07",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b8-9ea0-7128-a97c-2cacb74c91e8.webp",
      "image_media": {
        "alt_text": "Bedroom with carpet, sliding door closet, and a window with blinds.",
        "public_id": "019d20b8-9ea0-7128-a97c-2cacb74c91e8",
        "storage_key": "property/6767906449166878/019d20b8-9ea0-7128-a97c-2cacb74c91e8.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring soft carpeting, a convenient sliding door closet, and a large window with blinds offering natural light.",
      "link": "false",
      "alt_text": "Bedroom with carpet, sliding door closet, and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_VacantCanyonIISecondBedroom.jpg"
    },
    {
      "id": "ec_0ee4cd0e3f5b6ce29fb598f1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-dfc8-7656-904d-d7d8aa7ca4ee.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, vanity, and mirror.",
        "public_id": "019d08a9-dfc8-7656-904d-d7d8aa7ca4ee",
        "storage_key": "property/6767906449166878/019d08a9-dfc8-7656-904d-d7d8aa7ca4ee.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Step into a clean and functional bathroom featuring a spacious tub/shower combo, a modern vanity with ample storage, and a large mirror.",
      "link": "false",
      "alt_text": "Bathroom with bathtub, vanity, and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_VacantCanyonIISecondBathroom.jpg"
    },
    {
      "id": "ec_523264b50c318544bfec09dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-ec90-7578-8758-5ae683fa5404.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, black countertops, stainless steel sink, and black stove.",
        "public_id": "019f4aa4-ec90-7578-8758-5ae683fa5404",
        "storage_key": "property/6767906449166878/019f4aa4-ec90-7578-8758-5ae683fa5404.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring honey-toned wooden cabinets, durable speckled black countertops, and essential appliances including a dishwasher, sink, and electric range.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, black countertops, stainless steel sink, and black stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_LaurelJrVacantKitchen.jpg"
    },
    {
      "id": "ec_2b55e9eb79f68f8abda6d44f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-f1b8-73e8-b913-fe8172475bee.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, black granite countertops, black appliances, and a stainless steel sink.",
        "public_id": "019f4aa4-f1b8-73e8-b913-fe8172475bee",
        "storage_key": "property/6767906449166878/019f4aa4-f1b8-73e8-b913-fe8172475bee.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "This kitchen features light wood cabinetry, black granite countertops, a black stove and refrigerator, and a stainless steel sink. A window provides natural light.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, black granite countertops, black appliances, and a stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_LaurelJrVacantKitchenWindow.jpg"
    },
    {
      "id": "ec_35fdfa1ff70be436232f7335",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-f810-708d-bc48-4b22b1162cd2.webp",
      "image_media": {
        "alt_text": "Living room with large window and blinds, leading to kitchen and hallway.",
        "public_id": "019f4aa4-f810-708d-bc48-4b22b1162cd2",
        "storage_key": "property/6767906449166878/019f4aa4-f810-708d-bc48-4b22b1162cd2.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living area with a large window, plush carpeting, and an open view to the kitchen and hallway.",
      "link": "false",
      "alt_text": "Living room with large window and blinds, leading to kitchen and hallway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_LaurelJrVacantEntry.jpg"
    },
    {
      "id": "ec_56031950c2de09e6684830e2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-fa50-7633-a94f-64ad04900da3.webp",
      "image_media": {
        "alt_text": "Kitchen area with cabinets and appliances adjacent to a living space.",
        "public_id": "019f4aa4-fa50-7633-a94f-64ad04900da3",
        "storage_key": "property/6767906449166878/019f4aa4-fa50-7633-a94f-64ad04900da3.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Cozy kitchen featuring ample cabinet space and modern appliances, flowing into a comfortable living area with soft carpeting.",
      "link": "false",
      "alt_text": "Kitchen area with cabinets and appliances adjacent to a living space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_LaurelJrVacantKitchenHallway.jpg"
    },
    {
      "id": "ec_79e8feff3fd638527b5eff54",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-fee8-707e-bda8-2a5002e7a402.webp",
      "image_media": {
        "alt_text": "Empty living room with fireplace and large window.",
        "public_id": "019f4aa4-fee8-707e-bda8-2a5002e7a402",
        "storage_key": "property/6767906449166878/019f4aa4-fee8-707e-bda8-2a5002e7a402.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace and a large window with vertical blinds, ready for you to make it your own.",
      "link": "false",
      "alt_text": "Empty living room with fireplace and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_LaurelJrVacantLivingRoom.jpg"
    },
    {
      "id": "ec_bca91228fc625d6def704961",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-015c-734f-875c-37c389f6406a.webp",
      "image_media": {
        "alt_text": "Living room with a gas fireplace, vaulted ceiling, and large window overlooking trees.",
        "public_id": "019f4aa5-015c-734f-875c-37c389f6406a",
        "storage_key": "property/6767906449166878/019f4aa5-015c-734f-875c-37c389f6406a.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a gas fireplace and a vaulted ceiling, perfect for relaxation. Large windows provide ample natural light.",
      "link": "false",
      "alt_text": "Living room with a gas fireplace, vaulted ceiling, and large window overlooking trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_LaurelJrVacantFireplace.jpg"
    },
    {
      "id": "ec_df1e1cfbe8d80525cd9beb1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-04dc-708f-94bb-bef59fc8a6d9.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a closet and another room visible through an open doorway.",
        "public_id": "019f4aa5-04dc-708f-94bb-bef59fc8a6d9",
        "storage_key": "property/6767906449166878/019f4aa5-04dc-708f-94bb-bef59fc8a6d9.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "This is a view of an empty bedroom with neutral carpeting and walls. A closet is visible through an open door on the right, and another doorway leads to a different part of the apartment on the left.",
      "link": "false",
      "alt_text": "Empty bedroom with a closet and another room visible through an open doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_LaurelJrVacantBedroom.jpg"
    },
    {
      "id": "ec_937d1a8fcb9bf127b87d3f8b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-0779-77d2-874f-3f62f8f8eef8.webp",
      "image_media": {
        "alt_text": "Washer and dryer with a toilet visible in the adjacent room.",
        "public_id": "019f4aa5-0779-77d2-874f-3f62f8f8eef8",
        "storage_key": "property/6767906449166878/019f4aa5-0779-77d2-874f-3f62f8f8eef8.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "In-unit laundry area with washer and dryer, plus a separate toilet room.",
      "link": "false",
      "alt_text": "Washer and dryer with a toilet visible in the adjacent room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_LaurelJrVacantLaundry.jpg"
    },
    {
      "id": "ec_ff84c054fb9dfb67581d0c92",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-10da-75a3-af1c-aa030df977ad.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, vanity, and shower/tub combo.",
        "public_id": "019f4aa5-10da-75a3-af1c-aa030df977ad",
        "storage_key": "property/6767906449166878/019f4aa5-10da-75a3-af1c-aa030df977ad.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, a vanity with a granite-look countertop, and a white shower/tub combination.",
      "link": "false",
      "alt_text": "Bathroom with a toilet, vanity, and shower/tub combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_LaurelJrVacantBathroom.jpg"
    },
    {
      "id": "ec_e23b98187c46edde2ddf141f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-6a89-71df-b68e-0c163827361e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, white cabinets, and granite countertops.",
        "public_id": "019d08a9-6a89-71df-b68e-0c163827361e",
        "storage_key": "property/6767906449166878/019d08a9-6a89-71df-b68e-0c163827361e.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring sleek black appliances including a refrigerator, stove, and dishwasher, complemented by white cabinetry and durable granite countertops. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with black appliances, white cabinets, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_Vacant0x1Kitchen.jpg"
    },
    {
      "id": "ec_c27e24b036e7c20537bd91c9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-ea01-73ed-8132-3fa2680e6864.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances and white cabinetry.",
        "public_id": "019d08a9-ea01-73ed-8132-3fa2680e6864",
        "storage_key": "property/6767906449166878/019d08a9-ea01-73ed-8132-3fa2680e6864.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "A spacious and updated kitchen featuring black appliances, ample cabinet space, and a stylish countertop, perfect for home chefs.",
      "link": "false",
      "alt_text": "Modern kitchen with black appliances and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_Vacant0x1KitchenDiningArea.jpg"
    },
    {
      "id": "ec_c9959ed0904bdcc939f19c48",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-ec83-7461-a5df-2044a62b06d6.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment living area with a large window and closet space.",
        "public_id": "019d08a9-ec83-7461-a5df-2044a62b06d6",
        "storage_key": "property/6767906449166878/019d08a9-ec83-7461-a5df-2044a62b06d6.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Spacious apartment living area featuring plush carpeting, a large window for natural light, and ample closet storage. Perfect for creating your own comfortable home.",
      "link": "false",
      "alt_text": "Interior view of an empty apartment living area with a large window and closet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_Vacant0x1LivingRoomStorage.jpg"
    },
    {
      "id": "ec_458f5204649fa0d7451760cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-81ea-705f-ae4b-4a85bc40df5d.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelving",
        "public_id": "019d08a9-81ea-705f-ae4b-4a85bc40df5d",
        "storage_key": "property/6767906449166878/019d08a9-81ea-705f-ae4b-4a85bc40df5d.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving provides convenient storage.",
      "link": "false",
      "alt_text": "Walk-in closet with shelving",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_Vacant0x1ClosetStorage.jpg"
    },
    {
      "id": "ec_0e8e6aaff9dbfefcdde7e3d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08a9-f8a8-73dc-9e96-b9534e623f8f.webp",
      "image_media": {
        "alt_text": "View of an apartment showing a doorway to a closet and an open doorway to a bathroom vanity area.",
        "public_id": "019d08a9-f8a8-73dc-9e96-b9534e623f8f",
        "storage_key": "property/6767906449166878/019d08a9-f8a8-73dc-9e96-b9534e623f8f.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "This apartment features ample storage with a walk-in closet and a spacious bathroom vanity area, perfect for everyday convenience.",
      "link": "false",
      "alt_text": "View of an apartment showing a doorway to a closet and an open doorway to a bathroom vanity area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_Vacant0x1HallwayBathroom.jpg"
    },
    {
      "id": "ec_b5cace2e6452a553353b7129",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08aa-0229-751b-8323-71ad47406231.webp",
      "image_media": {
        "alt_text": "Empty closet with shelves and a bathroom vanity with double sinks and mirror.",
        "public_id": "019d08aa-0229-751b-8323-71ad47406231",
        "storage_key": "property/6767906449166878/019d08aa-0229-751b-8323-71ad47406231.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving next to a modern bathroom vanity featuring double sinks, a large mirror, and storage cabinets.",
      "link": "false",
      "alt_text": "Empty closet with shelves and a bathroom vanity with double sinks and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_Vacant0x1BathroomStorage.jpg"
    },
    {
      "id": "ec_c0c5b95d1f25ac7bbc4728f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b8-e175-73b9-8fb9-70486cecb9cf.webp",
      "image_media": {
        "alt_text": "Autumn Oaks Apartments monument sign with flags and landscaping.",
        "public_id": "019d20b8-e175-73b9-8fb9-70486cecb9cf",
        "storage_key": "property/6767906449166878/019d20b8-e175-73b9-8fb9-70486cecb9cf.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to Autumn Oaks Apartments, a Randall Apartment Community. The monument sign features the property name and logo, surrounded by lush greenery and flags.",
      "link": "false",
      "alt_text": "Autumn Oaks Apartments monument sign with flags and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_EntryMonument.jpg"
    },
    {
      "id": "ec_cf0e53c875d011fc654a33d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b8-ad7d-726b-adf3-5c3b9678c095.webp",
      "image_media": {
        "alt_text": "Exterior of the leasing office building with palm trees and parking lot.",
        "public_id": "019d20b8-ad7d-726b-adf3-5c3b9678c095",
        "storage_key": "property/6767906449166878/019d20b8-ad7d-726b-adf3-5c3b9678c095.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to our leasing office, where our friendly team is ready to assist you in finding your perfect home.",
      "link": "false",
      "alt_text": "Exterior of the leasing office building with palm trees and parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_Clubhouse.jpg"
    },
    {
      "id": "ec_65bb6c9e16782d68e6268572",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-1fe1-726f-b174-c6646b5b9a51.webp",
      "image_media": {
        "alt_text": "The leasing office entrance with a modern architectural design and lush landscaping.",
        "public_id": "019f4aa5-1fe1-726f-b174-c6646b5b9a51",
        "storage_key": "property/6767906449166878/019f4aa5-1fe1-726f-b174-c6646b5b9a51.webp",
        "width": 1800,
        "height": 2696
      },
      "title": "Community",
      "description": "Welcome to our leasing office, featuring a contemporary facade and beautiful surrounding greenery, inviting you to discover your new home.",
      "link": "false",
      "alt_text": "The leasing office entrance with a modern architectural design and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ClubhouseExteriorEntry.jpg"
    },
    {
      "id": "ec_d32b0c941dafe82e09b876f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-8c37-7480-8944-e7f4175e1485.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019f4aa4-8c37-7480-8944-e7f4175e1485",
        "storage_key": "property/6767906449166878/019f4aa4-8c37-7480-8944-e7f4175e1485.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Explore this spacious and modern kitchen, featuring dark wood cabinetry, granite countertops, and stainless steel appliances. Perfect for preparing meals and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ClubhouseKitchen.jpg"
    },
    {
      "id": "ec_c2582337af3d665ea0786d46",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-795f-71ec-8d5d-f0afb9c39891.webp",
      "image_media": {
        "alt_text": "Modern common area with a kitchen bar and seating area.",
        "public_id": "019f4aa4-795f-71ec-8d5d-f0afb9c39891",
        "storage_key": "property/6767906449166878/019f4aa4-795f-71ec-8d5d-f0afb9c39891.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish common area, featuring a full kitchen bar and comfortable lounge seating.",
      "link": "false",
      "alt_text": "Modern common area with a kitchen bar and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_Clubhouse(1).jpg"
    },
    {
      "id": "ec_641397b302383a06eea95f3e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-1602-726e-aff7-fadc5b288cbd.webp",
      "image_media": {
        "alt_text": "Community lounge area with sofas, chairs, a coffee table, and a TV.",
        "public_id": "019f4aa5-1602-726e-aff7-fadc5b288cbd",
        "storage_key": "property/6767906449166878/019f4aa5-1602-726e-aff7-fadc5b288cbd.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Relax and socialize in our comfortable community lounge, featuring plush seating, a large screen TV, and a stylish coffee table.",
      "link": "false",
      "alt_text": "Community lounge area with sofas, chairs, a coffee table, and a TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_ClubhouseLounge.jpg"
    },
    {
      "id": "ec_da6a2bcece74c1c5d9681297",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08aa-5884-77db-b6f2-04fdd63363c0.webp",
      "image_media": {
        "alt_text": "Business center with computers and a lounge area with a sofa and chairs.",
        "public_id": "019d08aa-5884-77db-b6f2-04fdd63363c0",
        "storage_key": "property/6767906449166878/019d08aa-5884-77db-b6f2-04fdd63363c0.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy our convenient business center, equipped with computers and printing facilities, as well as a comfortable lounge area for relaxation or informal meetings.",
      "link": "false",
      "alt_text": "Business center with computers and a lounge area with a sofa and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_BusinessCenter.jpg"
    },
    {
      "id": "ec_0696d34340172bd73db9a638",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-92e4-709d-8e6f-92e97aa99c72.webp",
      "image_media": {
        "alt_text": "Parcel pending lockers",
        "public_id": "019f4aa4-92e4-709d-8e6f-92e97aa99c72",
        "storage_key": "property/6767906449166878/019f4aa4-92e4-709d-8e6f-92e97aa99c72.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Convenient package lockers for secure and easy package retrieval.",
      "link": "false",
      "alt_text": "Parcel pending lockers",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_24HourPackageLockers.jpg"
    },
    {
      "id": "ec_3ab71287c7646b325009d3e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-19a4-721f-9d77-0812d055b355.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, treadmills, and elliptical machines.",
        "public_id": "019f4aa5-19a4-721f-9d77-0812d055b355",
        "storage_key": "property/6767906449166878/019f4aa5-19a4-721f-9d77-0812d055b355.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a variety of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with weight machines, treadmills, and elliptical machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_24HourFitnessCenter.jpg"
    },
    {
      "id": "ec_6fe587ab7759d502b683f01a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-7af8-7484-a9df-28ecef5ef129.webp",
      "image_media": {
        "alt_text": "Gym equipment in a community fitness center with mirrors and treadmills.",
        "public_id": "019f4aa4-7af8-7484-a9df-28ecef5ef129",
        "storage_key": "property/6767906449166878/019f4aa4-7af8-7484-a9df-28ecef5ef129.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a variety of cardio and strength training machines for a complete workout.",
      "link": "false",
      "alt_text": "Gym equipment in a community fitness center with mirrors and treadmills.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_24HourFitnessCenterMirrors.jpg"
    },
    {
      "id": "ec_3c8b88814dc192bea65aa9eb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-2659-74df-9e8e-71ef870e162f.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with cardio machines and weight training equipment.",
        "public_id": "019f4aa5-2659-74df-9e8e-71ef870e162f",
        "storage_key": "property/6767906449166878/019f4aa5-2659-74df-9e8e-71ef870e162f.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a variety of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Fully equipped fitness center with cardio machines and weight training equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_24HourFitnessCenterEquipment.jpg"
    },
    {
      "id": "ec_c6bd0897175b9922dd1c7e42",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-7d9e-74a2-8454-a001b5661743.webp",
      "image_media": {
        "alt_text": "Interior view of the laundry room with multiple washing and drying machines.",
        "public_id": "019f4aa4-7d9e-74a2-8454-a001b5661743",
        "storage_key": "property/6767906449166878/019f4aa4-7d9e-74a2-8454-a001b5661743.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with modern washers and dryers for resident use.",
      "link": "false",
      "alt_text": "Interior view of the laundry room with multiple washing and drying machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_LaundryFacility.jpg"
    },
    {
      "id": "ec_0be92a2a98a35d95b2ea1ec3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-7bab-76ac-91c2-73c459da6d6b.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool and hot tub area with lounge chairs and umbrellas.",
        "public_id": "019f4aa4-7bab-76ac-91c2-73c459da6d6b",
        "storage_key": "property/6767906449166878/019f4aa4-7bab-76ac-91c2-73c459da6d6b.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool or relax in the soothing hot tub. Plenty of lounge chairs and umbrellas are available for your comfort.",
      "link": "false",
      "alt_text": "Apartment complex swimming pool and hot tub area with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_SwimmingPoolSpa(1).jpg"
    },
    {
      "id": "ec_dbdd0cdc6b3e4facbf64e154",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-30b4-751a-b025-5b6bf3e5a9fd.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a hot tub.",
        "public_id": "019f4aa5-30b4-751a-b025-5b6bf3e5a9fd",
        "storage_key": "property/6767906449166878/019f4aa5-30b4-751a-b025-5b6bf3e5a9fd.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling swimming pool, complete with a soothing hot tub and comfortable lounge chairs.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a hot tub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_SwimmingPoolLounges.jpg"
    },
    {
      "id": "ec_e7ab7bcdc97010c1acf431ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-3724-7635-bd5b-55f5ec995e32.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs.",
        "public_id": "019f4aa5-3724-7635-bd5b-55f5ec995e32",
        "storage_key": "property/6767906449166878/019f4aa5-3724-7635-bd5b-55f5ec995e32.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs for ultimate relaxation.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_SwimmingPoolSideView.jpg"
    },
    {
      "id": "ec_7b5c036fe1e2630e7a686af7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-7b3a-7549-be56-c436b62448bb.webp",
      "image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and palm trees under a clear blue sky.",
        "public_id": "019f4aa4-7b3a-7549-be56-c436b62448bb",
        "storage_key": "property/6767906449166878/019f4aa4-7b3a-7549-be56-c436b62448bb.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush palm trees. Perfect for a relaxing afternoon under the sun.",
      "link": "false",
      "alt_text": "Bright blue swimming pool with lounge chairs and palm trees under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_SwimmingPoolDeck.jpg"
    },
    {
      "id": "ec_2b6202932b8f5e6bb08443c1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-4000-71e9-9d87-0abc5da19e81.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with a hot tub and lounge chairs.",
        "public_id": "019f4aa5-4000-71e9-9d87-0abc5da19e81",
        "storage_key": "property/6767906449166878/019f4aa5-4000-71e9-9d87-0abc5da19e81.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the resort-style swimming pool or unwind in the bubbling hot tub. Ample lounge chairs are available for soaking up the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with a hot tub and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_SwimmingPoolSpaAerial.jpg"
    },
    {
      "id": "ec_a4f8e32c544c708b0a35fb62",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-478f-76ae-9041-9bbdbdc0dbb6.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures in front of apartment buildings.",
        "public_id": "019f4aa5-478f-76ae-9041-9bbdbdc0dbb6",
        "storage_key": "property/6767906449166878/019f4aa5-478f-76ae-9041-9bbdbdc0dbb6.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring exciting slides and climbing structures for all ages. A perfect spot for family recreation.",
      "link": "false",
      "alt_text": "Playground with slides and climbing structures in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_Playground(1).jpg"
    },
    {
      "id": "ec_3be3846bc8d218c0f3020726",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-9412-70c3-97be-2303d13da57a.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing wall",
        "public_id": "019f4aa4-9412-70c3-97be-2303d13da57a",
        "storage_key": "property/6767906449166878/019f4aa4-9412-70c3-97be-2303d13da57a.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides and a climbing wall for endless entertainment.",
      "link": "false",
      "alt_text": "Playground with slides and climbing wall",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_PlaygroundBench.jpg"
    },
    {
      "id": "ec_30a345185df3105a84f012b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa4-9831-778d-b9e0-3d56e89db164.webp",
      "image_media": {
        "alt_text": "Playground tunnel for pets in a fenced dog park area.",
        "public_id": "019f4aa4-9831-778d-b9e0-3d56e89db164",
        "storage_key": "property/6767906449166878/019f4aa4-9831-778d-b9e0-3d56e89db164.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with tunnels and green space for your furry friends to play.",
      "link": "false",
      "alt_text": "Playground tunnel for pets in a fenced dog park area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_DogPark.jpg"
    },
    {
      "id": "ec_ab40573dd40bd5af8263dba7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019f4aa5-46ac-76ff-a96f-f69e4fe2ad19.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with wood chips, a play tunnel, and trees.",
        "public_id": "019f4aa5-46ac-76ff-a96f-f69e4fe2ad19",
        "storage_key": "property/6767906449166878/019f4aa5-46ac-76ff-a96f-f69e4fe2ad19.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with a fun play tunnel for your furry friends to explore.",
      "link": "false",
      "alt_text": "A fenced-in dog park with wood chips, a play tunnel, and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_DogParkLongView.jpg"
    },
    {
      "id": "ec_d5966817441a6fd74304e653",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b9-1241-744b-9b41-07e243a5a186.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and palm trees",
        "public_id": "019d20b9-1241-744b-9b41-07e243a5a186",
        "storage_key": "property/6767906449166878/019d20b9-1241-744b-9b41-07e243a5a186.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Discover comfortable living with modern exteriors and lush landscaping. Explore our community.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and palm trees",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_BuildingExteriorEntry.jpg"
    },
    {
      "id": "ec_785b2e0c3052e909152287f2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b8-fb24-77ed-a992-f1ba81d6304a.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building with blue siding and grey stucco, featuring balconies and staircases, surrounded by landscaping.",
        "public_id": "019d20b8-fb24-77ed-a992-f1ba81d6304a",
        "storage_key": "property/6767906449166878/019d20b8-fb24-77ed-a992-f1ba81d6304a.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Charming apartment building exterior showcasing a blend of blue siding and grey stucco. Enjoy the well-maintained grounds and balconies.",
      "link": "false",
      "alt_text": "Exterior view of an apartment building with blue siding and grey stucco, featuring balconies and staircases, surrounded by landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_BuildingExteriorWalkway.jpg"
    },
    {
      "id": "ec_003224bce65a7ea1857da041",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b9-0262-743b-b8c1-1e19ba8e26b9.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with blue and gray siding and outdoor staircases.",
        "public_id": "019d20b9-0262-743b-b8c1-1e19ba8e26b9",
        "storage_key": "property/6767906449166878/019d20b9-0262-743b-b8c1-1e19ba8e26b9.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Modern apartment buildings featuring a mix of blue and gray exterior siding, well-maintained landscaping, and convenient outdoor stair access.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with blue and gray siding and outdoor staircases.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_BuildingExteriorSide.jpg"
    },
    {
      "id": "ec_821b4e88778b13e210b2be5c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b9-2eb6-7720-8759-79912ae178db.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d20b9-2eb6-7720-8759-79912ae178db",
        "storage_key": "property/6767906449166878/019d20b9-2eb6-7720-8759-79912ae178db.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with blue siding and stucco, surrounded by green grass and trees. Features balconies and windows.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_BuildingExteriorPatiosDecks.jpg"
    },
    {
      "id": "ec_ab5766273350c4a00187bdeb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d20b9-3e09-734c-8984-f2b27ff920a2.webp",
      "image_media": {
        "alt_text": "Garage doors with blue roll-up doors in a parking lot with palm trees and trees.",
        "public_id": "019d20b9-3e09-734c-8984-f2b27ff920a2",
        "storage_key": "property/6767906449166878/019d20b9-3e09-734c-8984-f2b27ff920a2.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Convenient garage parking available for residents, providing secure storage for vehicles and belongings.",
      "link": "false",
      "alt_text": "Garage doors with blue roll-up doors in a parking lot with palm trees and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/AutumnOaks_Roseville_CA_Garages.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_4aeca21b-aad6-41e8-829d-707faa5cb2c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Topgolf Roseville",
      "poi_type": "Restaurants",
      "poi_address": "1700 Freedom Wy, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun golfing games, delicious appetizers, and a variety of cocktails. They highlight the reasonable prices, especially on weekdays, and the lively, high-energy atmosphere, perfect for date nights, family outings, and group gatherings. They also like the friendly and attentive service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-0790-718c-adb9-8771f070266d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-0790-718c-adb9-8771f070266d",
        "storage_key": "property/6767906449166878/019d08ad-0790-718c-adb9-8771f070266d.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://topgolf.com/us/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1683471834520779019&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-roseville",
      "poi_latitude": "38.7908306",
      "poi_longitude": "-121.2959577",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-200-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-bedb-7422-9b2b-ffe62b73a67a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-bedb-7422-9b2b-ffe62b73a67a",
        "storage_key": "property/6767906449166878/019d08ac-bedb-7422-9b2b-ffe62b73a67a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9QyJuochm4ARC3n8zbbkXBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2a3214cd-f35d-4cf3-8411-27ccc8a4b256",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "1803 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious cheeseburgers and animal fries. They highlight the fresh food, fast service, and affordable prices. They also like the friendly staff and clean dining area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-0835-746d-8b0f-ee742ce6dd1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-0835-746d-8b0f-ee742ce6dd1f",
        "storage_key": "property/6767906449166878/019d08ad-0835-746d-8b0f-ee742ce6dd1f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.in-n-out.com/132",
      "poi_directions_map_url": "https://maps.google.com/?cid=2664504733912924521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.758269",
      "poi_longitude": "-121.259566",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-bedb-7422-9b2b-ffe62b73a67a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-bedb-7422-9b2b-ffe62b73a67a",
        "storage_key": "property/6767906449166878/019d08ac-bedb-7422-9b2b-ffe62b73a67a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6GYqs-XwoARaQE6N_A4-iQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_1ecae4ae-1579-40e4-a4e1-47c180926efd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "1127 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious cheesecake, pasta, and other dishes, with a huge variety of options. They also highlight the friendly and attentive service, and the generous portions.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-2d9d-76d8-aef3-8074e4d53100.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2d9d-76d8-aef3-8074e4d53100",
        "storage_key": "property/6767906449166878/019d08ac-2d9d-76d8-aef3-8074e4d53100.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ca/roseville-140.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=3096057595972049366&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "38.773032",
      "poi_longitude": "-121.2685074",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-781-3399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-bedb-7422-9b2b-ffe62b73a67a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-bedb-7422-9b2b-ffe62b73a67a",
        "storage_key": "property/6767906449166878/019d08ac-bedb-7422-9b2b-ffe62b73a67a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi038SdQhm4AR1lkQ3Ppn9yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2e363499-4f92-4afe-9d54-e7e99852dd5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Yard House",
      "poi_type": "Restaurants",
      "poi_address": "1166 Roseville Pkwy Bldg E, Roseville, CA 95678, USA",
      "poi_short_description": "High-end sports-bar chain with a huge menu of New American fare & an extensive list of draft beers.",
      "poi_long_description": "People say this restaurant offers a wide variety of appetizers, including vampire tacos, sliders, and wings, as well as steak bowls and salmon. They also highlight the quick service, delicious drinks, and fun, lively atmosphere, and like the extensive selection of draft beers and ciders.\n\nOther reviews mention the noise level can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-36f4-75bf-a3b3-a9a7942d3d88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-36f4-75bf-a3b3-a9a7942d3d88",
        "storage_key": "property/6767906449166878/019d08ac-36f4-75bf-a3b3-a9a7942d3d88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yardhouse.com/locations/ca/roseville/roseville-the-fountains/8331?cmpid=br:yh_ag:ie_ch:loc_ca:YHGMB_sn:gmb_gt:roseville-ca-8331_pl:locurl_rd:1029",
      "poi_directions_map_url": "https://maps.google.com/?cid=5817699224790651083&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yard-house",
      "poi_latitude": "38.76887",
      "poi_longitude": "-121.270022",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-780-9273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-bedb-7422-9b2b-ffe62b73a67a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-bedb-7422-9b2b-ffe62b73a67a",
        "storage_key": "property/6767906449166878/019d08ac-bedb-7422-9b2b-ffe62b73a67a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4fub9Ehm4ARy1C2F5-evFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_254529d1-7fd3-4e3b-9dda-cd36cad7de98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1220 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fried chicken, and garlic toast. They also highlight the fresh food, quick service, and friendly staff.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-09d6-72ec-981d-ae262afe075a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-09d6-72ec-981d-ae262afe075a",
        "storage_key": "property/6767906449166878/019d08ad-09d6-72ec-981d-ae262afe075a.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ca/roseville/1220-galleria-boulevard",
      "poi_directions_map_url": "https://maps.google.com/?cid=14438597957049205901&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "38.7736002",
      "poi_longitude": "-121.2651215",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-547-5425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-bedb-7422-9b2b-ffe62b73a67a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-bedb-7422-9b2b-ffe62b73a67a",
        "storage_key": "property/6767906449166878/019d08ac-bedb-7422-9b2b-ffe62b73a67a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdw1hb1whm4ARjUSZzFc0YMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_b0ef060d-5e4e-4314-b164-cf59ecf32a36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Westfield Galleria at Roseville",
      "poi_type": "Shopping & Retail",
      "poi_address": "1151 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling shopping mall boasting top-name stores and eateries alongside family-friendly amenities.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, from luxury brands to budget-friendly options, as well as a food court and restaurants. They highlight the clean, spacious, and well-organized environment, and the ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-5151-750a-ac5b-0bb966bc5fc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-5151-750a-ac5b-0bb966bc5fc5",
        "storage_key": "property/6767906449166878/019d08ac-5151-750a-ac5b-0bb966bc5fc5.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.westfield.com/en/united-states/galleriaatroseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=5852009108560938456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westfield-galleria-at-roseville",
      "poi_latitude": "38.773542",
      "poi_longitude": "-121.26924",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-787-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-bed6-7519-9ab5-52cb216dd65f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-bed6-7519-9ab5-52cb216dd65f",
        "storage_key": "property/6767906449166878/019d08ac-bed6-7519-9ab5-52cb216dd65f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhTBR8Fked0AR2AUgakeDNlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b7a5b81b-84c4-4c35-9af1-9b94df845898",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, organic, and healthy food, including produce, meat, seafood, and ready-made entrees. They also highlight the clean and welcoming atmosphere, the friendly and helpful staff, and the excellent bakery.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-4942-773e-b21a-0944bcd525d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-4942-773e-b21a-0944bcd525d4",
        "storage_key": "property/6767906449166878/019d08ac-4942-773e-b21a-0944bcd525d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/roseville?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=30447028617915124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "38.7673904",
      "poi_longitude": "-121.2672481",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-781-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-bed4-719e-b01a-f2c893957600.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-bed4-719e-b01a-f2c893957600",
        "storage_key": "property/6767906449166878/019d08ac-bed4-719e-b01a-f2c893957600.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtS4AVtQhm4AR9Ko8RWkrbAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_cb7d2e34-a915-47ed-ba68-aa17d0f65088",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10151 Fairway Dr WinCo, Roseville, CA 95678, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of products, including fresh produce, bulk foods, and candy. They highlight the low prices, great deals, and excellent value. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-0f14-7539-bf78-363b56e0cf33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-0f14-7539-bf78-363b56e0cf33",
        "storage_key": "property/6767906449166878/019d08ad-0f14-7539-bf78-363b56e0cf33.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3355687902784976035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "38.7851269",
      "poi_longitude": "-121.27854",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-783-6090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-bed4-719e-b01a-f2c893957600.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-bed4-719e-b01a-f2c893957600",
        "storage_key": "property/6767906449166878/019d08ac-bed4-719e-b01a-f2c893957600.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxH4Fekhm4ARo_SSTl7MkS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_bbca3db2-cbfb-4c17-8d2f-01239749ccc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1117 Roseville Square, Roseville, CA 95678, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Shoppers say this grocery store offers a wide variety of products including their own brand of Rolled Corn Tortilla Chips, orange chicken, and unexpected finds like vegan Tzatziki. They also highlight the friendly and helpful staff, reasonable prices, and fresh produce.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-47cc-72b5-a610-a35522119dd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-47cc-72b5-a610-a35522119dd2",
        "storage_key": "property/6767906449166878/019d08ac-47cc-72b5-a610-a35522119dd2.webp",
        "width": 1280,
        "height": 1174
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/roseville/80/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13791252673358186453&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.7462886",
      "poi_longitude": "-121.274886",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-784-9084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-bed4-719e-b01a-f2c893957600.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-bed4-719e-b01a-f2c893957600",
        "storage_key": "property/6767906449166878/019d08ac-bed4-719e-b01a-f2c893957600.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTRdVD0gm4AR1ccruzxfZL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ef49cc28-8d61-484b-a9b6-bde8c387138f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "10001 Fairway Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has a wide selection of products and equipment rentals. They also highlight the friendly and helpful staff, and the well-maintained garden area.\n\nOther reviews mention the parking lot can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-0eeb-7312-9bbc-569e5fa977ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-0eeb-7312-9bbc-569e5fa977ba",
        "storage_key": "property/6767906449166878/019d08ad-0eeb-7312-9bbc-569e5fa977ba.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.homedepot.com/l/Stanford-Ranch/CA/Roseville/95678/6688?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8682696703861530084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "38.783274",
      "poi_longitude": "-121.2744493",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-787-0201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-bed6-7519-9ab5-52cb216dd65f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-bed6-7519-9ab5-52cb216dd65f",
        "storage_key": "property/6767906449166878/019d08ac-bed6-7519-9ab5-52cb216dd65f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIUrsBeghm4AR5B0fNqYif3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_704fbfc8-130f-46d3-a91a-be6d16733973",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Sierra College",
      "poi_type": "Education",
      "poi_address": "5100 Sierra College Blvd, Rocklin, CA 95677, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-6a61-7259-9b9e-f9c6a86205c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-6a61-7259-9b9e-f9c6a86205c1",
        "storage_key": "property/6767906449166878/019d08ac-6a61-7259-9b9e-f9c6a86205c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sierracollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7035051336990397408&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sierra-college",
      "poi_latitude": "38.7909585",
      "poi_longitude": "-121.2108548",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-624-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c407-75bf-b55a-8390ac343604.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c407-75bf-b55a-8390ac343604",
        "storage_key": "property/6767906449166878/019d08ac-c407-75bf-b55a-8390ac343604.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ737sfwem4AR4BPz7eqFoWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_986de955-bf56-4599-a31a-7514e9349c83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Jessup University",
      "poi_type": "Education",
      "poi_address": "2121 University Ave, Rocklin, CA 95765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-adc2-7350-83e5-14206dae76e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-adc2-7350-83e5-14206dae76e7",
        "storage_key": "property/6767906449166878/019d08ac-adc2-7350-83e5-14206dae76e7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://jessup.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13733206301315708494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jessup-university",
      "poi_latitude": "38.8203949",
      "poi_longitude": "-121.292457",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-577-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c407-75bf-b55a-8390ac343604.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c407-75bf-b55a-8390ac343604",
        "storage_key": "property/6767906449166878/019d08ac-c407-75bf-b55a-8390ac343604.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrVlwI0cim4ARTjYUkV4mlr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b8f68339-5990-4df6-9a84-cfecce82ae49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Roseville Golfland Sunsplash",
      "poi_type": "Entertainment",
      "poi_address": "1893 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Amusement chain featuring mini golf courses & arcades, some branches with water slides & laser tag.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including mini golf, go-karts, an arcade, and a water park with slides and a lazy river. They also highlight the well-maintained courses, the friendly and helpful staff, and the family-friendly atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-6a82-71f9-9e20-b755d92aa14c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-6a82-71f9-9e20-b755d92aa14c",
        "storage_key": "property/6767906449166878/019d08ac-6a82-71f9-9e20-b755d92aa14c.webp",
        "width": 1140,
        "height": 755
      },
      "poi_business_url": "http://www.golfland.com/roseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=13763917757911760307&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseville-golfland-sunsplash",
      "poi_latitude": "38.7615002",
      "poi_longitude": "-121.2579841",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-784-1273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQmp14Ufm4ARs30FxkZCA78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_97365a0d-9d27-4964-99e2-20eda96a9bc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Vernon Street Town Square",
      "poi_type": "Entertainment",
      "poi_address": "311 Vernon St, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly event destination featuring a splash pad and concerts throughout the year.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-1263-709d-8291-be0aee72f5ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-1263-709d-8291-be0aee72f5ef",
        "storage_key": "property/6767906449166878/019d08ad-1263-709d-8291-be0aee72f5ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roseville.ca.us/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10388886401199227140&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vernon-street-town-square",
      "poi_latitude": "38.747918",
      "poi_longitude": "-121.2844672",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-772-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3cGlzggm4ARBMFdoyO9LJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_f7fb568a-acfe-4070-98ab-3b2631761db6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Maidu Museum & Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "1970 Johnson Ranch Dr, Roseville, CA 95661, USA",
      "poi_short_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_long_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-7054-76ad-b90d-a5be53690d66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-7054-76ad-b90d-a5be53690d66",
        "storage_key": "property/6767906449166878/019d08ac-7054-76ad-b90d-a5be53690d66.webp",
        "width": 800,
        "height": 532
      },
      "poi_business_url": "https://www.roseville.ca.us/residents/maidu_museum_historic_site",
      "poi_directions_map_url": "https://maps.google.com/?cid=12030190500831605979&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-museum--historic-site",
      "poi_latitude": "38.73852",
      "poi_longitude": "-121.2457804",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-774-5934",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c8a3-7343-ad73-c6b80845c23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c8a3-7343-ad73-c6b80845c23c",
        "storage_key": "property/6767906449166878/019d08ac-c8a3-7343-ad73-c6b80845c23c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3cp0-Efm4AR27RYloXS86Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7a6c21ba-a43d-4e27-b6f5-3f68f9ca4b4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Sierra College Natural History Museum - SCNHM",
      "poi_type": "Entertainment",
      "poi_address": "5100 Sierra College Blvd, Rocklin, CA 95677, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-1494-7377-87ee-7455ae887813.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-1494-7377-87ee-7455ae887813",
        "storage_key": "property/6767906449166878/019d08ad-1494-7377-87ee-7455ae887813.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "https://www.sierracollege.edu/campus-life/things-to-do-on-campus/natural-history-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=180864048181489185&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sierra-college-natural-history-museum---scnhm",
      "poi_latitude": "38.7907223",
      "poi_longitude": "-121.2138816",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-660-7923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c8a3-7343-ad73-c6b80845c23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c8a3-7343-ad73-c6b80845c23c",
        "storage_key": "property/6767906449166878/019d08ac-c8a3-7343-ad73-c6b80845c23c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJscOnwvwem4ARIS5_wOSOggI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4a6b79ee-04e3-4983-b873-0535e2777635",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Roseville Utility Exploration Center",
      "poi_type": "Entertainment",
      "poi_address": "1501 Pleasant Grove Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "Learning center with creative exhibits on sustainability topics such as energy & water conservation.",
      "poi_long_description": "Learning center with creative exhibits on sustainability topics such as energy & water conservation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-7216-742d-984e-2afe96d5ceb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-7216-742d-984e-2afe96d5ceb4",
        "storage_key": "property/6767906449166878/019d08ac-7216-742d-984e-2afe96d5ceb4.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.roseville.ca.us/explore",
      "poi_directions_map_url": "https://maps.google.com/?cid=910903833852852384&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseville-utility-exploration-center",
      "poi_latitude": "38.7674387",
      "poi_longitude": "-121.332085",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-746-1550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c8a3-7343-ad73-c6b80845c23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c8a3-7343-ad73-c6b80845c23c",
        "storage_key": "property/6767906449166878/019d08ac-c8a3-7343-ad73-c6b80845c23c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJR8ooIkAhm4ARoDhX8TUupAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ebc9d6e1-9a18-4364-a052-e125b3110e6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1435 E Roseville Pkwy, Roseville, CA 95661, USA",
      "poi_short_description": "Gym with a cafe, an outdoor pool and spa, plus a mix of classes and personal trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-85e8-72c9-97eb-14a2187954c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-85e8-72c9-97eb-14a2187954c4",
        "storage_key": "property/6767906449166878/019d08ac-85e8-72c9-97eb-14a2187954c4.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ca/roseville.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=857371607747484135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.7619047",
      "poi_longitude": "-121.2446626",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-472-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-SMM5cfm4AR51lLSO_-5Qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8be6de30-096f-4e47-b4f6-e3c2f14d2e5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1533 Blue Oaks Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "Clean 24-hour fitness center offering weight training and cardio machines, plus personal training.",
      "poi_long_description": "People say this gym offers a wide variety of cardio equipment, weightlifting racks, and classes, as well as a sauna, cold plunge, and hot tub. They also highlight the friendly and helpful staff, and the clean facilities.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-16c2-70b0-b16c-d72514bc2f86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-16c2-70b0-b16c-d72514bc2f86",
        "storage_key": "property/6767906449166878/019d08ad-16c2-70b0-b16c-d72514bc2f86.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/roseville-ca/west-roseville-super-sport",
      "poi_directions_map_url": "https://maps.google.com/?cid=6961004575732605694&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.7936837",
      "poi_longitude": "-121.3276887",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 279-399-7106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ag-VlIjm4AR_iJp2Md0mmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_be14b741-3d12-424d-ae29-fc042334d58b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Villa Sport Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "291 Conference Center Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly fitness centre featuring a pool with a waterslide, plus a spa and a kids' club.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-1946-70d3-80b1-487498ab95b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-1946-70d3-80b1-487498ab95b1",
        "storage_key": "property/6767906449166878/019d08ad-1946-70d3-80b1-487498ab95b1.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.villasport.com/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436146082975352668&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "villa-sport-athletic-club",
      "poi_latitude": "38.7790663",
      "poi_longitude": "-121.271663",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-831-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS90qpfghm4ARXIcYMKikry8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f6d26434-8a4c-40d2-a445-18ecae9c2649",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "1232 Galleria Blvd Ste 100, Roseville, CA 95678, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-1dd2-77ff-8c06-0d07914a2240.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-1dd2-77ff-8c06-0d07914a2240",
        "storage_key": "property/6767906449166878/019d08ad-1dd2-77ff-8c06-0d07914a2240.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/roseville-ca-103",
      "poi_directions_map_url": "https://maps.google.com/?cid=5127848378555817095&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "38.773455",
      "poi_longitude": "-121.2612387",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-780-1117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fSv930fm4ARh9zhie7GKUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_2ce34a55-3fb0-4bf1-8c5a-b055ed146aad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1159 Roseville Square Ste 100, Roseville, CA 95678, USA",
      "poi_short_description": "Clean, friendly, well-equipped facility that's part of a chain.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-872d-7651-92f3-e3509ba93c45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-872d-7651-92f3-e3509ba93c45",
        "storage_key": "property/6767906449166878/019d08ac-872d-7651-92f3-e3509ba93c45.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/roseville-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11658269411521409879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.7468683",
      "poi_longitude": "-121.2740643",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-604-8235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq0EtYWchm4ARVzOJ-UJ-yqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cfcff9cf-a44a-458a-9b92-34d109f9ead9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Gold's Gym - Citrus Heights",
      "poi_type": "Health and Wellness",
      "poi_address": "8485 Auburn Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Spacious chain gym offering a variety of exercise machines and weights including cardio options, along with friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and is regularly updated. They highlight the gym is stress-free and organized, and the staff are friendly and welcoming. They also like the positive and supportive culture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-1e76-73dd-a5dd-d3492c49ef89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-1e76-73dd-a5dd-d3492c49ef89",
        "storage_key": "property/6767906449166878/019d08ad-1e76-73dd-a5dd-d3492c49ef89.webp",
        "width": 960,
        "height": 350
      },
      "poi_business_url": "http://www.goldsgym.com/citrus-heights/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11983788150103413449&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golds-gym---citrus-heights",
      "poi_latitude": "38.7203476",
      "poi_longitude": "-121.2916771",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-241-8939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfeXk-4nfmoARyRJzZtT3TqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ff85a330-4a78-449e-af6f-685a44660e90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "In-Shape Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2165 Sunset Blvd, Rocklin, CA 95765, USA",
      "poi_short_description": "Chain fitness center with a swimming pool, Pilates studio, and yoga studio, plus child care.",
      "poi_long_description": "People say this gym offers a large pool, sauna, steam room, and a variety of exercise equipment. They also highlight the friendly staff, the awesome daycare, and the beautiful views.\n\nOther reviews mention the facilities can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-1f27-73c9-ac69-39f0b7840c3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-1f27-73c9-ac69-39f0b7840c3b",
        "storage_key": "property/6767906449166878/019d08ad-1f27-73c9-ac69-39f0b7840c3b.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.inshape.com/gyms/rocklin?utm_source=G&utm_medium=Local&utm_campaign=Google-Local&utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18437040336201676890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-shape-fitness",
      "poi_latitude": "38.8067933",
      "poi_longitude": "-121.2731016",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-435-2141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv-qDMPkhm4ARWnjZjICG3f8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b25c9539-3d1d-4796-8b56-1342567e15da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Sutter Roseville Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Medical Plaza Dr, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-799f-76bc-bc68-3bce9fede5a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-799f-76bc-bc68-3bce9fede5a5",
        "storage_key": "property/6767906449166878/019d08ac-799f-76bc-bc68-3bce9fede5a5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sutterhealth.org/find-location/facility/sutter-roseville-medical-center-1043247063",
      "poi_directions_map_url": "https://maps.google.com/?cid=16416276433024432869&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutter-roseville-medical-center",
      "poi_latitude": "38.7665119",
      "poi_longitude": "-121.2493364",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-781-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c929-7256-aab2-3888b7f3c816.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c929-7256-aab2-3888b7f3c816",
        "storage_key": "property/6767906449166878/019d08ac-c929-7256-aab2-3888b7f3c816.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZKeApsfm4AR5boJTXBU0uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0e9befbc-f66f-46b7-8c26-9bc32d84727b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Kaiser Permanente Roseville Medical Center - Building C",
      "poi_type": "Health and Wellness",
      "poi_address": "1660 Eureka Rd, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-233b-70bb-895a-95014ee9704d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-233b-70bb-895a-95014ee9704d",
        "storage_key": "property/6767906449166878/019d08ad-233b-70bb-895a-95014ee9704d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thrive.kaiserpermanente.org/care-near-you/northern-california/northvalley/locations/roseville-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12837480181016674950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-roseville-medical-center---building-c",
      "poi_latitude": "38.7455188",
      "poi_longitude": "-121.2488626",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-784-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c929-7256-aab2-3888b7f3c816.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c929-7256-aab2-3888b7f3c816",
        "storage_key": "property/6767906449166878/019d08ac-c929-7256-aab2-3888b7f3c816.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVgDhXMfm4ARhsKdcDXkJ7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a72d912f-dbd3-4b89-acdb-1239df880148",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Maidu Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1550 Maidu Dr, Roseville, CA 95661, USA",
      "poi_short_description": "A 152-acre park that includes a community center, library & museum, plus many sports facilities.",
      "poi_long_description": "People say this park offers baseball fields, softball fields, a skate park, walking trails, and a playground. They highlight the spaciousness, shade, and well-maintained facilities, as well as the convenient parking and nearby amenities like a library and community center. They also like the farmers market on Sundays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-93d9-73ed-b7e4-28b0eb8188b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-93d9-73ed-b7e4-28b0eb8188b8",
        "storage_key": "property/6767906449166878/019d08ac-93d9-73ed-b7e4-28b0eb8188b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/maidu_regional_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13221982917698702125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-regional-park",
      "poi_latitude": "38.7348068",
      "poi_longitude": "-121.2526237",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-774-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c93a-743d-9dd4-76f08c7d79f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c93a-743d-9dd4-76f08c7d79f7",
        "storage_key": "property/6767906449166878/019d08ac-c93a-743d-9dd4-76f08c7d79f7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xooih3gmoARLcu2G2nrfbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b2063c03-a26c-4c9a-b527-41b4a2026bbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Johnson-Springview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5480 5th St, Rocklin, CA 95677, USA",
      "poi_short_description": "This expansive community resource features sport courts & fields, a playground & a dog park.",
      "poi_long_description": "People say this park offers a disc golf course, dog park, playground, splash pad, tennis courts, and walking trails. They highlight the park is beautiful, well-maintained, and has a wide variety of activities for all ages. They also like the spacious picnic areas, clean restrooms, and ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-98d3-73d4-bc7d-003d46c3a1af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-98d3-73d4-bc7d-003d46c3a1af",
        "storage_key": "property/6767906449166878/019d08ac-98d3-73d4-bc7d-003d46c3a1af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rocklin.ca.us/depts/parksnrec/parks/johnson_springview_park.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091168952253734584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "johnson-springview-park",
      "poi_latitude": "38.7900911",
      "poi_longitude": "-121.2447255",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-625-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c93a-743d-9dd4-76f08c7d79f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c93a-743d-9dd4-76f08c7d79f7",
        "storage_key": "property/6767906449166878/019d08ac-c93a-743d-9dd4-76f08c7d79f7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxyn8Gkfm4ARuN5E85sHMO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fccdff43-9bbd-428c-a6fb-e5c873bf95e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Rusch Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7801 Auburn Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Outdoor skating & biking spot with concrete surface, numerous unique features & lighting at night.",
      "poi_long_description": "People say this park offers a wide variety of amenities, including pickleball courts, tennis courts, a swimming pool, playgrounds, and walking trails. They also highlight the clean and well-maintained grounds, and the spacious open areas perfect for picnics and recreational activities.\n\nOther reviews mention there can be homeless people.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-2566-71fd-97b2-5312f60d7f49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-2566-71fd-97b2-5312f60d7f49",
        "storage_key": "property/6767906449166878/019d08ad-2566-71fd-97b2-5312f60d7f49.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://sunriseparks.com/rusch-community-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=352438582190195855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rusch-community-park",
      "poi_latitude": "38.70897069999999",
      "poi_longitude": "-121.2912232",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c93a-743d-9dd4-76f08c7d79f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c93a-743d-9dd4-76f08c7d79f7",
        "storage_key": "property/6767906449166878/019d08ac-c93a-743d-9dd4-76f08c7d79f7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCebD9pDfmoARj8SW8AUd5AQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1fc774c8-a329-4b9c-bd14-3d5ad1115d9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Gibson Ranch Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8556 Gibson Ranch Park Rd, Elverta, CA 95626, USA",
      "poi_short_description": "Large park with nature trails, farm animals, horseback riding, camping, outdoor concerts & events.",
      "poi_long_description": "People say this park offers fishing, picnic areas, and walking trails. They highlight the spacious green grass, beautiful views, and family-friendly atmosphere. They also like the ample parking, well-maintained facilities, and availability of barbecue pits and seating for large groups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-2624-72d8-b67e-88769e36b832.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-2624-72d8-b67e-88769e36b832",
        "storage_key": "property/6767906449166878/019d08ad-2624-72d8-b67e-88769e36b832.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "http://regionalparks.saccounty.net/Parks/RegionalParksDetails/Pages/GibsonRanch.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6179385611734743009&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gibson-ranch-regional-park",
      "poi_latitude": "38.723755",
      "poi_longitude": "-121.4034049",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 916-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c93a-743d-9dd4-76f08c7d79f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c93a-743d-9dd4-76f08c7d79f7",
        "storage_key": "property/6767906449166878/019d08ac-c93a-743d-9dd4-76f08c7d79f7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJUOh66snm4AR4febXXmWwVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e380a6ee-3a04-43ea-ad34-c08ee522e023",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Harry Crabb Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Scarborough Dr, Roseville, CA 95661, USA",
      "poi_short_description": "Popular family park featuring a splash pad, as well as swings and sand volleyball courts.",
      "poi_long_description": "Visitors say this park has a great splash pad and water park, as well as volleyball courts, a baseball field, a basketball court, a tennis court, a playground, a picnic area, and soccer fields. They also highlight that the park is clean and well-maintained, with bathrooms available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-2720-73ba-95eb-f1af7989bfa1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-2720-73ba-95eb-f1af7989bfa1",
        "storage_key": "property/6767906449166878/019d08ad-2720-73ba-95eb-f1af7989bfa1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/crabb_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15538028085356412488&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harry-crabb-park",
      "poi_latitude": "38.7691293",
      "poi_longitude": "-121.2346673",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-774-5748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c93a-743d-9dd4-76f08c7d79f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c93a-743d-9dd4-76f08c7d79f7",
        "storage_key": "property/6767906449166878/019d08ac-c93a-743d-9dd4-76f08c7d79f7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk348haMfm4ARSD62OTgqotc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ec025833-e95b-47e9-a630-8af7cb7e19bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Adventist Health Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Adventist Health Way, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-2a0d-77b6-9be8-f125a4e8cda6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-2a0d-77b6-9be8-f125a4e8cda6",
        "storage_key": "property/6767906449166878/019d08ad-2a0d-77b6-9be8-f125a4e8cda6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://adventisthealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7527772297905000202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "adventist-health-corporate-office",
      "poi_latitude": "38.7569855",
      "poi_longitude": "-121.2519719",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-406-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncKXiO8fm4ARCk-nZgUFeGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cbff6e8c-37ec-45ec-b5dd-d1e3767934b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Hewlett Packard Enterprise",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8000 Foothills Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-2c55-723e-a766-57e6bd58abcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-2c55-723e-a766-57e6bd58abcc",
        "storage_key": "property/6767906449166878/019d08ad-2c55-723e-a766-57e6bd58abcc.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.hpe.com/us/en/home.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11168594821131035904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hewlett-packard-enterprise",
      "poi_latitude": "38.7849688",
      "poi_longitude": "-121.3163292",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 888-342-2156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJURi8130hm4ARAGXI6dDR_po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5f531bcf-84cd-49e4-8d8e-24761f0c2ccd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Alta California Regional Center - Roseville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "516 Gibson Dr #150, Roseville, CA 95678, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.altaregional.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16993152713332891207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alta-california-regional-center---roseville",
      "poi_latitude": "38.779814",
      "poi_longitude": "-121.2730978",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-437-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47RgO_Yfm4ARRx4s9FvO0-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f8caf82f-5b8a-4bfb-800a-f545686d5440",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "Norcanna Farms Cannabis Delivery",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6929 Sunrise Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ad-2c7d-766a-ac74-24eba46aa913.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-2c7d-766a-ac74-24eba46aa913",
        "storage_key": "property/6767906449166878/019d08ad-2c7d-766a-ac74-24eba46aa913.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://norcannafarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13645295156685364849&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norcanna-farms-cannabis-delivery",
      "poi_latitude": "38.69166260000001",
      "poi_longitude": "-121.2721073",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-671-3446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxpQROffmoARcd6WLabTXb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2963cc2c-4633-421a-93cc-4e3f3b131263",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "custom",
      "poi_name": "KRATOS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2901 Douglas Blvd STE 105, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kratosusd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=313016841676869165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kratos",
      "poi_latitude": "38.74523629999999",
      "poi_longitude": "-121.2387311",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-991-1990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-c402-77bc-8851-943f1304a22a",
        "storage_key": "property/6767906449166878/019d08ac-c402-77bc-8851-943f1304a22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ8lKct0fm4ARLU7duCgPWAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f7242eea4d9d47b71de81bea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_75a70c451ac4319c6a44a41b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_d9aea082acb3d242035a24f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_35c81c2659fc2895f43b0b2c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_b5a6240640c65839baae33bd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_99912c7373fd69b2ff36d4ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_63f2a03d527ec0dba0a4b894",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "rating": "4",
      "name": "JJiNNieE LL",
      "text": "This will be a very long review. I tried to keep it short, but still long cause I’ve lived here for too long. 😅  My husband and I lived in this apartment complex for more than 10 years (I believe at least since 2012), and we truly loved it here. However, the past three years have been little difficult for me. Unfortunately, the tenants living below us during this time were very inconsiderate, often rude, and lacked basic apartment manners. The apartment management was  addressing issues related to smoking, to reduce smoke and air pollution. I appreciated their efforts to maintain a smoke-free environment. However, noise pollution can be just as disruptive. No one wants to hear loud music through the walls or floors when trying to relax at home after a long day at work. For the last three years, after moving from the old side of the complex to the newer side, I dealt with constant noise issues.  Although the office addressed after-hours noise and tried to assist during the day, they were limited by policy, which only regulates noise during \"quiet hours.\" I understand the policy, but I believe there should be stricter rules regarding noise, even during the day, to ensure a more pleasant living environment. Many apartment complexes have a \"covenant of quiet enjoyment\" written into their leases to protect tenants' rights to live undisturbed. Improving the quality of life in the complex should be prioritized over amenities like having two pools, new paint on the outside of the building, or installing laminated wood floors. For the past three years, I had to wear noise-canceling headphones or earplugs to sleep. This caused me significant stress, impacting my mental and physical health. Working 8-10 hour shifts without being able to sleep well or relax at home took a serious toll on me. And I’m not someone who doesn’t understand reasonable noise. Watching a movie with loud volume that echoes through my entire bedroom until midnight on a Sunday, playing piano after quiet hours until midnigh, having a party till midnight  and more is not understandable noise.. The noise issues began after we moved to the newer side of the complex due to stairway repairs. (We MOVED TWICE because of this issue). The office staff was very helpful, offering us reasonable deals and assistance, but moving twice in a few years is no easy task. At least the current downstairs neighbors stopped being loud after we notified the office about their noise problem with evidences of recordings. I could tell they were trying to keep the noise down, which we appreciated, but they were still loud after quiet hours time to time. My husband and I just STOPPED caring. We didn’t bother calling the office again or calling after hour security. I eventually reached my breaking point and realized the issue couldn’t be solved, as some people simply don’t respect their neighbor. We just started the moving process as soon as we got the key to our new house on 10th and began living there right away. After stressful years, we finally moved out and returned key.\n\nMy husband and I want to thank the staff at Autumn Oaks Apartments for their hard work and kindness throughout our time here. We really didn’t have any issues with office or mainantence. They were always fast and friendly. (I’m just wondering how much they’re going to charge us after move out check.🤔 I hired a cleaning service to clean two bathrooms and the kitchen-including the inside of the oven and fridge. And I slightly vecumned carpet since I know they are gonna replace it. I've been paying an additional $25 pet fee every months for years for that anyway 😂)\n\nIt has been a delightful journey at Autumn Oaks for many years. We wish Autumn Oaks all the best and hope they continue to improve the community for their residents. It’s just a little sad because this was once a peaceful and beautiful complex, but unfortunately, a few disrespectful tenants have tarnished its reputation.",
      "date": "2024-10-31",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_bd8a244264d7001d68bb2b81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Autumn Oaks Apartments, Roseville, CA - Studio 540 Sq. Ft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019e4fdc-bb1a-77ac-a0c7-7780942ce09f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e4fdc-bb1a-77ac-a0c7-7780942ce09f",
        "storage_key": "property/6767906449166878/019e4fdc-bb1a-77ac-a0c7-7780942ce09f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Emory",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=w57AB6m16pE"
    },
    {
      "id": "ec_e3515bf1c459c1dddcec3b87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Autumn Oaks Apartments, Roseville, CA - 1 Bedroom 1 Bath 608 Sq. Ft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019e4fdc-ba7a-7569-895c-2b0478c08365.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e4fdc-ba7a-7569-895c-2b0478c08365",
        "storage_key": "property/6767906449166878/019e4fdc-ba7a-7569-895c-2b0478c08365.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Laurel",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DxJsdRg5wGe"
    },
    {
      "id": "ec_5f74625abbd2d1207b247006",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Autumn Oaks Apartments 1 Bedroom 1 Bath 700 Square Feet.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019ddcf4-5058-72dd-b143-e3d6196f51ad.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf4-5058-72dd-b143-e3d6196f51ad",
        "storage_key": "property/6767906449166878/019ddcf4-5058-72dd-b143-e3d6196f51ad.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Willow",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9Ev32PNoncK"
    },
    {
      "id": "ec_3f72537718d1820dfb8171c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019ddcf4-50d4-700e-aca5-aa0257046a09.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf4-50d4-700e-aca5-aa0257046a09",
        "storage_key": "property/6767906449166878/019ddcf4-50d4-700e-aca5-aa0257046a09.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Silverleaf",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eWZMFNWggRy"
    },
    {
      "id": "ec_176b888b076621a59df0dbc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Autumn Oaks Apartments 945 sq. ft. 2 bedroom 2 bath.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019ddcf4-506e-72cc-94ff-c42fb1bcf687.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf4-506e-72cc-94ff-c42fb1bcf687",
        "storage_key": "property/6767906449166878/019ddcf4-506e-72cc-94ff-c42fb1bcf687.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Canyon II",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2xiW9yBBJeu"
    },
    {
      "id": "ec_6725bc1ee635309d04b325b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Autumn Oaks Apartments 3 Bedroom 2 Bath 1138 Square Feet.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019ddcf4-503a-74ef-bb01-ff47df2b92b3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf4-503a-74ef-bb01-ff47df2b92b3",
        "storage_key": "property/6767906449166878/019ddcf4-503a-74ef-bb01-ff47df2b92b3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Scarlet",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=sWgeMU6DSuz"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a9c99-2866-70b6-acae-2bcfba53c8e5",
      "lead_source": "LANDING_PAGE",
      "name": "ctl-autumn-oaks-apartments-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "dog-park-apartments-roseville-ca-autumn-oaks",
      "search_query": "dog park apartments in Roseville CA",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Roseville, CA",
      "h2_subtitle": "Looking for apartments with a dog park in Roseville, CA? Autumn Oaks Apartments welcomes you and your furry friends with open paws.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Autumn Oaks Apartments. For pet lovers searching for dog park apartments in Roseville, CA, our community includes a spacious dog park, perfect for daily playtime and socialization. Nestled in the charming Kaseberg - Kingswood neighborhood, Autumn Oaks offers a serene living environment combined with modern amenities such as online rent payments and service requests.\n\nWhether you're relaxing in your comfortable apartment with scenic views or letting your pup roam free in the dog park, Autumn Oaks delivers a tailored residential experience. We offer various floor plans from studios to three-bedroom options, each designed with you and your pets in mind. Contact us today to schedule a tour and see why Autumn Oaks is the ideal choice for both you and your four-legged companion.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Roseville, CA | Autumn Oaks",
      "seo_description": "Find your home at Autumn Oaks Apartments in Roseville, CA. Enjoy a dedicated dog park, perfect for pet owners. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-placer-county-autumn-oaks",
      "search_query": "smoke free apartments in Placer County",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments in Placer County",
      "h2_subtitle": "Searching for smoke-free living in Placer County? Autumn Oaks Apartments offers a welcoming, healthy environment for all residents.",
      "page_copy": "Experience the benefits of a healthier, cleaner living environment at Autumn Oaks Apartments, proudly offering smoke-free apartments in Placer County. Our community sets the standard for clean air living, perfect for those prioritizing wellness. Located in vibrant Roseville, within the charming Kaseberg - Kingswood community, Autumn Oaks ensures you’re surrounded by the natural beauty that complements our health-focused amenities.\n\nAt Autumn Oaks, enjoy a range of modern facilities, including a dog park, a playground, and the convenience of online service requests and rent payments. With our variety of studio to three-bedroom apartment options, you're sure to find a home that suits your lifestyle. Embrace the benefits of smoke-free living at Autumn Oaks and schedule a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments in Placer County | Autumn Oaks",
      "seo_description": "Autumn Oaks Apartments in Placer County offers a clean, smoke-free environment. Enjoy a healthier lifestyle. Book a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "clubhouse-apartments-kaseberg-kingswood-autumn-oaks",
      "search_query": "apartments with clubhouse in Kaseberg-Kingswood",
      "category": "Amenity",
      "h1_title": "Apartments with Clubhouse in Kaseberg-Kingswood",
      "h2_subtitle": "Explore Autumn Oaks for a vibrant lifestyle in Kaseberg-Kingswood. Our clubhouse offers a welcoming community space.",
      "page_copy": "Nestled in the heart of the Kaseberg-Kingswood neighborhood, Autumn Oaks Apartments presents an ideal home for those seeking apartments with a clubhouse. Our community helps foster connections and create lasting memories with friends and neighbors in our welcoming clubhouse setting. Just moments away from vibrant local attractions, Autumn Oaks provides a blend of convenience and comfort perfectly situated in Roseville, CA.\n\nBeyond the clubhouse, Autumn Oaks offers a plethora of amenities including a playground, scenic views, and a dedicated dog park, ensuring a lifestyle rich in both leisure and relaxation. Available in studio, one, two, or three-bedroom options, our apartments cater to various living preferences. Make Autumn Oaks your new home today, where a community lifestyle and modern comforts await.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Clubhouse in Kaseberg-Kingswood",
      "seo_description": "Discover clubhouse apartments at Autumn Oaks in Kaseberg-Kingswood. Enjoy community living with modern amenities in Roseville, CA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "online-services-apartment-95678-autumn-oaks",
      "search_query": "online services apartment in 95678",
      "category": "Amenity",
      "h1_title": "Online Services Apartment in 95678",
      "h2_subtitle": "Autumn Oaks Apartments in 95678 offers modern online service conveniences. Experience seamless living in Roseville, CA.",
      "page_copy": "Enjoy the ease of modern living at Autumn Oaks Apartments, where we offer advanced online services in the 95678 area. Our residents benefit from the convenience of online rent payments and service requests, allowing you to manage your living experience effortlessly and securely from anywhere. Located in the welcoming Roseville community, Autumn Oaks combines comfort with cutting-edge technology to ensure a stress-free lifestyle.\n\nIn addition to our online offerings, Autumn Oaks Apartments provide an array of amenities such as a dog park and playground, making it the ideal home for families and pets. Choose from our versatile floor plans, ranging from studios to three-bedroom options, tailored to meet varied lifestyle needs. Visit Autumn Oaks today and discover how our online services can enhance your apartment living in Roseville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Online Services Apartment in 95678 | Autumn Oaks",
      "seo_description": "Autumn Oaks Apartments offers convenient online services in 95678. Streamline your life with easy online payments and requests. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "scenic-view-apartments-roseville-autumn-oaks",
      "search_query": "apartments with scenic views in Roseville",
      "category": "Amenity",
      "h1_title": "Apartments with Scenic Views in Roseville",
      "h2_subtitle": "Discover stunning scenic views at Autumn Oaks Apartments in Roseville. Embrace a serene lifestyle with picturesque surroundings.",
      "page_copy": "At Autumn Oaks Apartments in Roseville, immerse yourself in the natural beauty that makes our community stand out. Our apartments are designed to offer scenic views, making every day a picturesque experience. Nestled in the vibrant city of Roseville, within the Kaseberg-Kingswood neighborhood, Autumn Oaks ensures that breathtaking landscapes are just a glance away.\n\nOur community offers a variety of amenities, including a dog park and playground, complemented by our smoke-free living options for a healthy environment. Choose from a selection of studio, one, two, or three-bedroom floor plans that cater to different lifestyles. Experience the harmony of nature and modern comfort at Autumn Oaks, where scenic views offer a daily retreat into tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Scenic Views in Roseville | Autumn Oaks",
      "seo_description": "Enjoy scenic views at Autumn Oaks Apartments in Roseville, CA. Embrace serenity in a comfortable, well-located community. Book your visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "studio-apartments-roseville-ca-autumn-oaks",
      "search_query": "studio apartments in Roseville CA",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Roseville, CA",
      "h2_subtitle": "Explore efficient studio living at Autumn Oaks Apartments in Roseville, CA. Experience compact comfort with endless flexibility.",
      "page_copy": "Welcome to Autumn Oaks Apartments in Roseville, CA, where our studio apartments offer a perfect blend of efficiency and comfort. Ideal for singles or couples, our studios are designed to provide a cozy environment without sacrificing style or amenities. Located in the dynamic Kaseberg-Kingswood neighborhood, our community connects you to everything Roseville has to offer while serving as a peaceful retreat from city life.\n\nAt Autumn Oaks, you’ll enjoy modern conveniences such as online rent payments and service requests, coupled with community features like a scenic dog park and playground. With easily accessible public spaces and a smoke-free environment, your ideal studio apartment awaits. Schedule a tour today and see how studio living in Roseville can be both affordable and luxurious.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Roseville, CA | Autumn Oaks",
      "seo_description": "Discover studio apartments at Autumn Oaks in Roseville, CA. Enjoy modern living with convenient amenities. Visit us for your perfect compact home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "one-bedroom-apartment-kaseberg-kingswood-autumn-oaks",
      "search_query": "one bedroom apartment near Kaseberg Kingswood",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartment Near Kaseberg Kingswood",
      "h2_subtitle": "Discover comfortable one-bedroom living at Autumn Oaks, just steps away from the Kaseberg-Kingswood neighborhood.",
      "page_copy": "Searching for a one-bedroom apartment near Kaseberg-Kingswood? Look no further than Autumn Oaks Apartments in Roseville. Our thoughtfully designed one-bedroom units provide a spacious and inviting living environment that caters to your lifestyle needs. Located in the heart of the vibrant Kaseberg-Kingswood area, Autumn Oaks offers convenient access to local attractions and essential services.\n\nResidents enjoy a host of amenities, including scenic views that enhance everyday living, a community playground, and a dedicated dog park for pet lovers. Plus, with our online service requests and rent payments, managing your living experience has never been easier. Visit Autumn Oaks today to discover why our one-bedroom apartments are the perfect fit for modern living in the Roseville area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartment Near Kaseberg Kingswood",
      "seo_description": "Find a one-bedroom apartment near Kaseberg-Kingswood at Autumn Oaks in Roseville. Enjoy modern amenities and community living. Schedule your visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-placer-county-autumn-oaks",
      "search_query": "two bedroom apartments Placer County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Placer County",
      "h2_subtitle": "Explore spacious two-bedroom apartments at Autumn Oaks, located in the heart of Placer County.",
      "page_copy": "Experience the charm of Autumn Oaks Apartments, offering versatile two-bedroom layouts perfect for families and roommates in Placer County. Our units provide ample living space and modern amenities that cater to diverse lifestyles, ensuring every resident feels at home. Nestled within the Kaseberg-Kingswood neighborhood, our community boasts a tranquil yet convenient location in Roseville.\n\nAutumn Oaks provides residents with a variety of community perks, including a dog park, beautifully landscaped views, and a playground for leisure and recreation. Enjoy the convenience of online service requests and rent payments, making life at Autumn Oaks as seamless as it is enjoyable. Discover the ideal two-bedroom apartment today and become part of a welcoming community that values comfort and accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Placer County | Autumn Oaks",
      "seo_description": "Discover two-bedroom apartments in Placer County at Autumn Oaks. Enjoy spacious living with modern amenities in a vibrant community. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-95678-autumn-oaks",
      "search_query": "three bedroom apartments 95678",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in 95678",
      "h2_subtitle": "Enjoy spacious three-bedroom living at Autumn Oaks, nestled in the 95678 area of Roseville.",
      "page_copy": "For those seeking roomy three-bedroom apartments in the 95678 area, Autumn Oaks Apartments provides an ideal solution. Each of our three-bedroom units offers ample space for family living or sharing among roommates, with features designed to enhance comfort and ease. Situated in the peaceful Kaseberg-Kingswood neighborhood, our community provides a harmonious balance of suburban tranquility and city convenience.\n\nResidents benefit from a variety of on-site amenities, such as a playground for children, a park for pets, and scenic views that highlight the natural beauty of Placer County. With the added convenience of online rent payments and service requests, Autumn Oaks ensures hassle-free living. Choose Autumn Oaks for your three-bedroom needs and enjoy a vibrant community atmosphere in Roseville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in 95678 | Autumn Oaks",
      "seo_description": "Explore three-bedroom apartments in the 95678 area at Autumn Oaks. Enjoy spacious living and modern amenities. Schedule your visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "apartments-near-vencil-brown-elementary-autumn-oaks",
      "search_query": "apartments near Vencil Brown Elementary School Roseville",
      "category": "School",
      "h1_title": "Apartments Near Vencil Brown Elementary School",
      "h2_subtitle": "Find ideal family-friendly apartments close to Vencil Brown Elementary School in Roseville at Autumn Oaks.",
      "page_copy": "Discover the convenience of living at Autumn Oaks Apartments, located just moments away from Vencil Brown Elementary School in Roseville. Our community offers a comfortable and safe environment suitable for families, with a selection of floor plans from studios to spacious three-bedroom apartments, making it easy to find the right fit for your family needs.\n\nAutumn Oaks boasts a variety of amenities that enhance daily life, such as a scenic playground, a dog park perfect for pet owners, and online services that simplify rent payments and maintenance requests. The close proximity to Vencil Brown Elementary ensures that student commutes are quick and stress-free, leaving more time for family activities. Experience the perfect blend of convenience and community by choosing Autumn Oaks as your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Vencil Brown Elementary School",
      "seo_description": "Find family-friendly apartments near Vencil Brown Elementary in Roseville. Enjoy modern amenities and a convenient location at Autumn Oaks. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "kaseberg-school-apartments-placer-county-autumn-oaks",
      "search_query": "Kaseberg School apartments in Placer County",
      "category": "School",
      "h1_title": "Kaseberg School Apartments in Placer County",
      "h2_subtitle": "Live near Kaseberg School with our welcoming apartments in Placer County at Autumn Oaks.",
      "page_copy": "Autumn Oaks Apartments offers an ideal living experience for families seeking proximity to Kaseberg School in Placer County. Our community features diverse floor plans, from studios to three-bedroom options, ensuring a perfect match for your family's needs and lifestyle. Located in the Kaseberg-Kingswood neighborhood, residents enjoy easy access to educational facilities and other conveniences nearby.\n\nExperience the benefits of living in a community that caters to your lifestyle with amenities like a playground, scenic views, and a dog park. Autumn Oaks also provides modern conveniences such as online rent payments and service requests, making everyday tasks effortless. Embrace a community-focused lifestyle by making Autumn Oaks your new home near Kaseberg School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kaseberg School Apartments | Autumn Oaks Placer County",
      "seo_description": "Discover family-friendly apartments near Kaseberg School at Autumn Oaks in Placer County. Enjoy modern amenities and convenient living. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "apartments-close-to-maidu-elementary-autumn-oaks",
      "search_query": "apartments close to Maidu Elementary School Roseville",
      "category": "School",
      "h1_title": "Apartments Close to Maidu Elementary School",
      "h2_subtitle": "Find your ideal home near Maidu Elementary School in Roseville at Autumn Oaks Apartments.",
      "page_copy": "At Autumn Oaks Apartments, families seeking homes close to Maidu Elementary School in Roseville will find a welcoming and convenient community. Our selection of studios to three-bedroom apartments offers flexible living options that accommodate various family sizes and requirements. Located in the serene Kaseberg-Kingswood area, Autumn Oaks provides an excellent setting for families focused on education and community.\n\nOur community is designed to enhance family life with a range of amenities, including a playground, a dog park, and picturesque views for residents to enjoy. Simplify your daily routines with features like online rent payments and maintenance requests. With its prime location near Maidu Elementary, Autumn Oaks Apartments ensures a balance of comfort, convenience, and community for your family.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Maidu Elementary School | Autumn Oaks",
      "seo_description": "Discover spacious apartments near Maidu Elementary School at Autumn Oaks in Roseville. Enjoy modern amenities and a convenient location. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "buljan-middle-school-nearby-autumn-oaks",
      "search_query": "Buljan Middle School nearby Roseville CA",
      "category": "School",
      "h1_title": "Near Buljan Middle School in Roseville, CA",
      "h2_subtitle": "Live close to Buljan Middle School with our family-friendly apartments at Autumn Oaks in Roseville, CA.",
      "page_copy": "Families searching for a home conveniently near Buljan Middle School in Roseville, CA will find Autumn Oaks Apartments meets their needs perfectly. Situated in the Kaseberg-Kingswood neighborhood, our community offers a variety of floor plans from studios to three-bedroom options, ideal for accommodating families of all sizes.\n\nAutumn Oaks enhances living with amenities such as a dog park, playground, and scenic views, fostering a welcoming environment. Residents benefit from hassle-free living with online rent payments and service requests. The close proximity to Buljan Middle School ensures students have a quick and easy commute, allowing more time for educational and extracurricular pursuits, making Autumn Oaks an excellent choice for your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Buljan Middle School Roseville, CA",
      "seo_description": "Discover family-friendly apartments near Buljan Middle School at Autumn Oaks in Roseville. Enjoy convenient living with modern amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "woodcreek-high-school-vicinity-apartments-autumn-oaks",
      "search_query": "Woodcreek High School vicinity apartments Roseville",
      "category": "School",
      "h1_title": "Apartments Near Woodcreek High School",
      "h2_subtitle": "Explore our apartments in the Woodcreek High School vicinity in Roseville, offering comfort and convenience.",
      "page_copy": "Located in the Kaseberg-Kingswood neighborhood of Roseville, Autumn Oaks Apartments is ideally situated for families seeking apartments near Woodcreek High School. Our community offers a range of floor plans from studios to spacious three-bedroom units, ensuring a fitting home for various family dynamics. \n\nResidents of Autumn Oaks enjoy modern amenities, including a dog park and a playground, creating a vibrant environment for relaxation and community interaction. The property supports a modern lifestyle with online rent payments and service requests, simplifying residents' daily routines. Living near Woodcreek High School allows students and families to experience the convenience of a short commute, further enhancing the appeal of making Autumn Oaks your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Vicinity Apartments Near Woodcreek High School",
      "seo_description": "Find comfort and convenience at Autumn Oaks, with apartments near Woodcreek High School in Roseville. Schedule a tour today to explore our community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "roseville-high-school-area-apartments-95678",
      "search_query": "Roseville High School area apartments 95678",
      "category": "School",
      "h1_title": "Apartments Near Roseville High School 95678",
      "h2_subtitle": "Discover apartments near Roseville High School in the 95678 area at Autumn Oaks, featuring exceptional amenities and a vibrant community.",
      "page_copy": "For families looking to settle in the vicinity of Roseville High School within the 95678 zip code, Autumn Oaks Apartments offers the perfect residential setting. Nestled in the peaceful Kaseberg-Kingswood neighborhood, our community provides a variety of floor plans ranging from cozy studios to expansive three-bedroom options, catering to diverse family needs.\n\nAutumn Oaks ensures a comfortable lifestyle with amenities like a playground, dog park, and scenic views. Our commitment to convenience is further highlighted by online rent payments and service request systems. Its strategic location near Roseville High School makes Autumn Oaks ideal for families seeking an easy commute to school and a welcoming community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Roseville High School Area Apartments | Autumn Oaks",
      "seo_description": "Explore apartments near Roseville High School in 95678 at Autumn Oaks. Enjoy modern living with easy access to education. Contact us to schedule a visit!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "arbor-view-montessori-close-apartments-autumn-oaks",
      "search_query": "Arbor View Montessori close apartments Roseville",
      "category": "School",
      "h1_title": "Apartments Near Arbor View Montessori",
      "h2_subtitle": "Discover our family-focused apartments near Arbor View Montessori in Roseville, perfect for easy access to quality education.",
      "page_copy": "Autumn Oaks Apartments offer an excellent option for families searching for proximity to Arbor View Montessori in Roseville. Located in the serene Kaseberg-Kingswood neighborhood, our community features a range of floor plans from studio to three-bedroom units, ideal for accommodating both small and larger family sizes.\n\nResidents enjoy amenities such as a playground and a dog park, promoting a family-friendly atmosphere. The ease of online rent payments and service requests facilitates modern living. The close distance to Arbor View Montessori ensures a short commute, allowing families more quality time together while maintaining an easy connection with educational resources.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close Apartments Near Arbor View Montessori Roseville",
      "seo_description": "Find family-friendly apartments near Arbor View Montessori in Roseville at Autumn Oaks. Enjoy convenience and comfort. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "apartments-near-sierra-college-placer-county-autumn-oaks",
      "search_query": "apartments near Sierra College Placer County",
      "category": "School",
      "h1_title": "Apartments Near Sierra College, Placer County",
      "h2_subtitle": "Explore Autumn Oaks Apartments, conveniently located near Sierra College in Placer County, offering an ideal lifestyle for students and professionals.",
      "page_copy": "Autumn Oaks Apartments in Roseville is the perfect choice for those seeking residences near Sierra College in Placer County. Located in the Kaseberg-Kingswood neighborhood, our community provides an array of floor plans from cozy studios to expansive three-bedroom units, perfect for students and professionals alike.\n\nAutumn Oaks offers amenities designed to enhance daily life, including scenic views and a dog park, alongside practical features like online service requests and rent payments. With its prime position near Sierra College, residents benefit from a short commute, making it an excellent option for those who value convenience and accessibility in their educational and professional pursuits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Apartments Near Sierra College, Placer County",
      "seo_description": "Autumn Oaks offers apartments near Sierra College in Placer County. Enjoy modern amenities and an ideal location. Contact us to learn more or schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "apartments-near-sutter-roseville-medical-center",
      "search_query": "apartments near sutter roseville medical center",
      "category": "Hospital",
      "h1_title": "Apartments Near Sutter Roseville Medical Center",
      "h2_subtitle": "Find comfort and convenience at Autumn Oaks Apartments, located near Sutter Roseville Medical Center, perfect for healthcare professionals.",
      "page_copy": "Autumn Oaks Apartments in Roseville offers an exceptional living option for those seeking proximity to Sutter Roseville Medical Center. Nestled in the tranquil Kaseberg-Kingswood area, our versatile floor plans include studios and up to three-bedroom units, ideal for healthcare professionals and their families.\n\nEnjoy a hassle-free lifestyle with amenities such as a playground, dog park, and easy access to scenic views. Our online systems for rent payments and service requests add to your convenience. Being close to Sutter Roseville Medical Center means having a short commute, allowing more personal time and seamless work-life balance in this serene community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Living Near Sutter Roseville Medical Center",
      "seo_description": "Discover Autumn Oaks Apartments near Sutter Roseville Medical Center. Ideal for healthcare professionals seeking comfort and proximity. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "housing-close-to-kaiser-roseville-medical-center",
      "search_query": "housing close to kaiser permanente roseville medical center placer county",
      "category": "Hospital",
      "h1_title": "Housing Near Kaiser Permanente Roseville",
      "h2_subtitle": "Autumn Oaks Apartments offer ideal housing options near Kaiser Permanente Roseville Medical Center in Placer County.",
      "page_copy": "Located in the serene neighborhood of Kaseberg-Kingswood, Autumn Oaks Apartments provide excellent housing options for those seeking proximity to Kaiser Permanente Roseville Medical Center in Placer County. Our community offers a range of floor plans, from cozy studios to spacious three-bedroom apartments, perfect for accommodating diverse needs.\n\nResidents can enjoy convenient amenities like a dog park, a playground, and scenic views, all enhancing the quality of living. The community also supports a modern lifestyle with online services for rent payments and maintenance requests. Living near Kaiser Permanente doesn't just mean shorter commutes, but also more personal time in a welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Kaiser Permanente Roseville in Placer County",
      "seo_description": "Find comfortable housing close to Kaiser Permanente Roseville Medical Center at Autumn Oaks, offering modern amenities and a convenient location in Placer County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "apartments-near-mahany-park-roseville",
      "search_query": "apartments near Mahany Park Roseville",
      "category": "Park",
      "h1_title": "Apartments Near Mahany Park, Roseville",
      "h2_subtitle": "Discover Autumn Oaks Apartments, ideally situated near Mahany Park in Roseville, providing both comfort and proximity to local attractions.",
      "page_copy": "Autumn Oaks Apartments in Roseville offers an ideal setting for those looking to reside near the vibrant Mahany Park. Our diverse floor plans, including options from studios to three-bedroom units, cater to singles, couples, and families alike, providing a perfect home in the Kaseberg-Kingswood neighborhood.\n\nResidents enjoy amenities such as a scenic dog park, a family-friendly playground, and easy online services for stress-free living. With Mahany Park just a stone's throw away, you can engage in a variety of recreational activities and community events, making Autumn Oaks a perfect choice for active individuals and families.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Apartments Near Mahany Park, Roseville",
      "seo_description": "Live at Autumn Oaks Apartments near Mahany Park, Roseville. Enjoy modern amenities and easy access to park activities. Schedule your visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "rentals-close-to-kaseberg-park-95678",
      "search_query": "rentals close to Kaseberg Park 95678",
      "category": "Park",
      "h1_title": "Rentals Close to Kaseberg Park 95678",
      "h2_subtitle": "Explore Autumn Oaks Apartments, offering ideal rentals near Kaseberg Park in the 95678 area of Roseville.",
      "page_copy": "Nestled in the Kaseberg-Kingswood neighborhood of Roseville, Autumn Oaks Apartments provide excellent rental options for those looking to live close to Kaseberg Park. Our community offers a variety of floor plans—from studios to three-bedroom layouts—that are sure to meet your lifestyle needs.\n\nEnjoy the benefits of living near Kaseberg Park, a local hotspot for outdoor activities and relaxation. At Autumn Oaks, residents appreciate amenities like our dog park, playground, and scenic views, alongside modern conveniences such as online rent payments and service requests. Perfect for families and individuals seeking a vibrant community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Kaseberg Park in Roseville 95678",
      "seo_description": "Discover rentals at Autumn Oaks, close to Kaseberg Park, 95678. Perfect for enjoying local parks and modern amenities. Visit us to find your new home!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "living-by-royer-park-in-placer-county",
      "search_query": "living by Royer Park in Placer County",
      "category": "Park",
      "h1_title": "Living by Royer Park in Placer County",
      "h2_subtitle": "Autumn Oaks Apartments offer ideal living spaces near Royer Park in Placer County, perfect for convenience and relaxation.",
      "page_copy": "Explore the vibrant community of Autumn Oaks Apartments, located near the scenic Royer Park in Placer County. Our selection of studio, one, two, and three-bedroom floor plans accommodates various lifestyle needs, from singles to families.\n\nEnjoy the close proximity to Royer Park, where you can relish outdoor activities and community events. Combined with the benefits of Autumn Oaks' amenities, such as a dog park, playground, and efficient online services, living here provides both convenience and leisure. Experience life near Royer Park and discover your new home in our friendly community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Royer Park, Placer County Apartments",
      "seo_description": "Experience life at Autumn Oaks, near Royer Park, Placer County. Enjoy modern living with easy park access and top amenities. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "apartments-near-maidu-regional-park-roseville",
      "search_query": "apartments near Maidu Regional Park Roseville",
      "category": "Park",
      "h1_title": "Apartments Near Maidu Regional Park, Roseville",
      "h2_subtitle": "Discover Autumn Oaks Apartments, ideally located near Maidu Regional Park in Roseville, offering comfort and accessibility.",
      "page_copy": "For those seeking a home near Maidu Regional Park, Autumn Oaks Apartments in Roseville provides the perfect blend of convenience and comfort. Choose from an array of floor plans, including studio, one, two, and three-bedroom options, tailored to suit diverse lifestyles.\n\nOur residents benefit from amenities like a dedicated dog park, a playful playground, and seamless online services—all contributing to a stress-free living experience. Situated close to Maidu Regional Park, you can easily partake in outdoor activities and enjoy the park's natural beauty. Make Autumn Oaks your new home and enjoy everything the neighborhood has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Roseville Apartments Near Maidu Regional Park",
      "seo_description": "Find your new home at Autumn Oaks Apartments, near Maidu Regional Park, Roseville. Enjoy modern amenities and the park's natural charm. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "roseville-apartments-by-johnson-springview-park",
      "search_query": "Roseville apartments by Johnson-Springview Park",
      "category": "Park",
      "h1_title": "Roseville Apartments by Johnson-Springview Park",
      "h2_subtitle": "Live at Autumn Oaks Apartments, just a short drive from Johnson-Springview Park in beautiful Roseville.",
      "page_copy": "Experience the advantage of living near Johnson-Springview Park at Autumn Oaks Apartments in Roseville. Our community offers a range of floor plans from studios to three-bedroom apartments, ensuring a perfect fit for everyone.\n\nResidents enjoy access to fantastic amenities, including a relaxing dog park, a fun-filled playground, and user-friendly online services. Living close to Johnson-Springview Park means having recreational opportunities right at your doorstep, along with the tranquility of lush landscapes. Consider Autumn Oaks your gateway to a vibrant Roseville lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Roseville Apartments Near Johnson-Springview Park",
      "seo_description": "Find Roseville apartments near Johnson-Springview Park at Autumn Oaks. Enjoy premium amenities and lush park proximity. Discover your ideal home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "living-near-pauline-richard-roccucci-park",
      "search_query": "living near Pauline and Richard Roccucci Park",
      "category": "Park",
      "h1_title": "Living Near Pauline and Richard Roccucci Park",
      "h2_subtitle": "Autumn Oaks Apartments offer incredible living near the serene Pauline and Richard Roccucci Park.",
      "page_copy": "At Autumn Oaks Apartments, experience the best of Roseville living, just moments from Pauline and Richard Roccucci Park. Our diverse range of floor plans, including spacious studios and up to three-bedroom homes, cater to varying preferences and family sizes.\n\nLiving near Pauline and Richard Roccucci Park means endless opportunities for outdoor enjoyment and community interaction. Our residents also benefit from convenient amenities such as a dog park, playground, and the ease of online service requests. Discover a well-rounded lifestyle at Autumn Oaks, where the park's beauty and recreational options are just steps away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pauline and Richard Roccucci Park",
      "seo_description": "Enjoy living near Roccucci Park at Autumn Oaks Apartments, Roseville. Modern amenities and park proximity make it an ideal home choice. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "robert-p-bob-mahan-park-nearby-apartments",
      "search_query": "Robert P. \"Bob\" Mahan Park nearby apartments",
      "category": "Park",
      "h1_title": "Robert P. \"Bob\" Mahan Park Nearby Apartments",
      "h2_subtitle": "Discover the convenience of Autumn Oaks Apartments, located near Robert P. \"Bob\" Mahan Park in Roseville.",
      "page_copy": "Looking for apartments near Robert P. \"Bob\" Mahan Park? Autumn Oaks Apartments offers the ideal location. With a variety of floor plans ranging from studios to three-bedroom units, our community caters to every need and lifestyle.\n\nEmbrace the vibrant living experience with amenities like a cozy dog park, a lively playground, and easy access to online services. Nestled close to Robert P. \"Bob\" Mahan Park, residents can enjoy the natural beauty and recreational facilities without leaving the neighborhood. Make Autumn Oaks Apartments your home and enjoy both comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Roseville Apartments Near Robert P. \"Bob\" Mahan Park",
      "seo_description": "Live near Robert P. \"Bob\" Mahan Park at Autumn Oaks Apartments in Roseville. Enjoy modern amenities and park access. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "astill-family-park-area-rentals",
      "search_query": "Astill Family Park area rentals",
      "category": "Park",
      "h1_title": "Astill Family Park Area Rentals",
      "h2_subtitle": "Autumn Oaks Apartments offer rentals near the family-friendly Astill Family Park in Roseville.",
      "page_copy": "Explore the charm of living near Astill Family Park with our rentals at Autumn Oaks Apartments. Perfectly situated, our community features a variety of floor plans, from cozy studios to spacious three-bedroom homes, ensuring a suitable choice for families and individuals alike.\n\nResidents enjoy a wealth of amenities, including a dog park for pet owners, a playground for outdoor fun, and the convenience of online service tools. Proximity to Astill Family Park means you can enjoy leisurely park walks and activities with family and friends right in your backyard. Discover the ideal blend of comfort and convenience at Autumn Oaks Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Roseville Rentals Near Astill Family Park",
      "seo_description": "Discover rentals near Astill Family Park at Autumn Oaks Apartments, Roseville. Enjoy great amenities and excellent park proximity. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "denio-family-park-close-apartments",
      "search_query": "Denio Family Park Roseville close apartments",
      "category": "Park",
      "h1_title": "Denio Family Park Close Apartments",
      "h2_subtitle": "Live near Denio Family Park at Autumn Oaks Apartments, perfectly situated for Roseville residents.",
      "page_copy": "Discover the advantage of living close to Denio Family Park at Autumn Oaks Apartments in Roseville. Our community offers a range of floor plans from studios to three-bedroom apartments, accommodating various lifestyle needs.\n\nWith amenities such as a dog park for your furry friends and a playground for children, Autumn Oaks Apartments is the perfect place to call home. Enjoy the convenience of online service requests and payments, while indulging in the natural beauty and recreational opportunities of nearby Denio Family Park. Choose Autumn Oaks for a comfortable living experience in a prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Roseville Apartments Near Denio Family Park",
      "seo_description": "Find close apartments at Autumn Oaks, near Denio Family Park in Roseville. Enjoy great amenities and park access. Schedule your visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166878",
      "source": "generator",
      "page_item_url": "apartments-near-sacramento-airport",
      "search_query": "apartments near Sacramento International Airport Roseville",
      "category": "Transit",
      "h1_title": "Apartments Near Sacramento Intl Airport",
      "h2_subtitle": "Autumn Oaks Apartments in Roseville offers easy access to Sacramento International Airport, perfect for frequent travelers.",
      "page_copy": "For those searching for apartments near Sacramento International Airport while residing in Roseville, Autumn Oaks Apartments is an ideal choice. Our community provides a range of living options, from studios to three-bedroom units, all set in a serene and smoke-free environment.\n\nAt Autumn Oaks Apartments, you’ll benefit from convenient amenities like a dog park and playground, while enjoying the ease of access to the airport for all your travel needs. With efficient online service requests and payment options, you can focus on what truly matters—enjoying your home and convenient travels. Choose Autumn Oaks for a stress-free and comfortable living experience near the airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and stucco.",
        "public_id": "019d08ab-f207-767b-806d-1c917661dfe0",
        "storage_key": "property/6767906449166878/019d08ab-f207-767b-806d-1c917661dfe0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Roseville Apartments Near Sacramento Airport",
      "seo_description": "Live at Autumn Oaks, near Sacramento International Airport. Enjoy modern amenities and easy travel access. Visit us in Roseville today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5603"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372403460"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M8Q7WDS4"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "51934476094"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-818-5581"
    }
  ],
  "custom_qb_id": "5603",
  "custom_repli_id": "18372403460",
  "custom_google_gtm_id": "GTM-M8Q7WDS4",
  "custom_hubspot_company_id": "51934476094",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-818-5581"
};

export const generatedAt = '2026-10-05T20:56:33.208Z';
